import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    // Navigation
    home: "Accueil",
    history: "Histoire",
    teachings: "Enseignements",
    events: "Événements",
    archives: "Archives",
    media: "Médiathèque",
    contact: "Contact",
    origins: "Les Origines",
    maodo: "Maodo (El Hadji Malick Sy)",
    heirsLineage: "Lignée des Héritiers",
    familyTree: "Arbre Généalogique",
    sacredGeography: "Géographie Sacrée",
    interactiveMap: "Carte Interactive",
    pillars: "Piliers de la Tariqa",
    school: "L'École de Tivaouane",
    referenceWorks: "Ouvrages de Référence",
    gamou: "Le Gamou",
    annualZiarra: "Ziarra Annuelles",
    religiousCeremonies: "Cérémonies Religieuses",
    
    // Page Origines
    originesTitle: "Les Origines",
    originesSubtitle: "De Fès à Tivaouane",
    originesHeroDesc: "L'histoire d'une voie soufie qui a traversé les siècles et les continents",
    originesGenesisTitle: "La Genèse de la Tijaniyya",
    foundingEvent: "L'événement fondateur",
    foundingEventDesc: "En 1781, à l'âge de 44 ans, Cheikh Ahmed Tijani reçoit en état de veille (yaqdha) la visite spirituelle du Prophète Muhammad (PSL) qui lui ordonne de fonder une nouvelle voie soufie et lui transmet directement le Wird (litanies quotidiennes).",
    directTransmissionDesc: "Cette révélation marque la naissance d'une Tariqa unique dans l'histoire du soufisme : contrairement aux autres voies qui s'appuient sur une chaîne (silsila) de maîtres remontant au Prophète, la Tidjanidya revendique une transmission directe, sans intermédiaire humain.",
    expansionChronology: "Chronologie de l'Expansion",
    tariqaSpecificities: "Les Spécificités de la Tariqa",
    arrivalWestAfrica: "L'Arrivée en Afrique de l'Ouest",
    arrivalIntro: "La Tijaniyya arrive en Afrique de l'Ouest au début du 19e siècle par plusieurs voies :",
    universalHeritage: "Un Héritage Universel",
    universalHeritageDesc: "Aujourd'hui, la Tijaniyya compte des millions de disciples à travers le monde, du Maroc au Nigeria, de la Mauritanie au Soudan. Tivaouane demeure l'un de ses centres spirituels les plus rayonnants, perpétuant l'enseignement authentique de Cheikh Ahmed Tijani à travers la lignée de Maodo.",
    
    // Page Géographie Sacrée
    holyCity: "Tivaouane, la Cité Sainte",
    geographieHeroDesc: "Pourquoi Tivaouane est devenue le centre névralgique de la Tidjanidya",
    tivaouaneTransformation: "Tivaouane : D'un Village à une Métropole Spirituelle",
    whyTivaouane: "Pourquoi Tivaouane ?",
    whyTivaouaneDesc: "Le choix de Tivaouane par Maodo n'était pas le fruit du hasard. Plusieurs facteurs stratégiques ont guidé cette décision :",
    distanceFromPower: "Distance vis-à-vis du pouvoir colonial",
    distanceFromPowerDesc: "Contrairement à Saint-Louis, capitale coloniale où il enseignait, Tivaouane offrait plus d'autonomie",
    centralPosition: "Position géographique centrale",
    centralPositionDesc: "Carrefour entre plusieurs régions, facilitant l'afflux de disciples",
    fertileLand: "Terre fertile et paisible",
    fertileLandDesc: "Propice à l'étude et à la méditation",
    rapidTransformation: "En l'espace de quelques années, Tivaouane se transforma en pôle intellectuel et spirituel. Des étudiants affluèrent de tout le Sénégal, de la Gambie, de la Mauritanie et même de la Guinée pour étudier auprès de Maodo.",
    emblematicPlaces: "Les Lieux Emblématiques",
    cityOrganization: "L'Organisation de la Cité",
    cityOrgIntro: "Tivaouane s'organise aujourd'hui autour de trois pôles principaux :",
    demographicMetamorphosis: "Une Métamorphose Démographique",
    uniqueCase: "Cette transformation fait de Tivaouane un cas unique en Afrique de l'Ouest : une ville dont l'identité et la prospérité sont entièrement liées à sa dimension spirituelle.",
    moreThanaCity: "Tivaouane : Plus qu'une Ville, un État d'Esprit",
    moreThanaDesc: "Tivaouane n'est pas seulement un lieu géographique. C'est un projet spirituel, une utopie réalisée où le savoir et la piété cohabitent, où les disciples de tous horizons se retrouvent dans l'amour du Prophète (PSL) et l'enseignement de Maodo.",
    cityOfLight: "Cité de la Lumière",
    
    // Page Ziarra
    ziarraTitle: "Les Ziarra Annuelles",
    spiritualPilgrimages: "Pèlerinages Spirituels",
    ziarraHeroDesc: "Les moments forts de communion spirituelle à Tivaouane",
    ziarraIntro1: "La ziarra (visite pieuse) est un moment essentiel dans la vie d'un disciple tidiane. Elle représente l'occasion de renouveler son engagement spirituel et de se ressourcer auprès des lieux saints.",
    ziarraIntro2: "Tivaouane accueille plusieurs ziarra tout au long de l'année, chacune ayant sa propre signification et son propre programme.",
    mainZiarras: "Les Principales Ziarra",
    program: "Programme",
    spiritualSignificance: "Signification spirituelle",
    pilgrimGuide: "Guide du Pèlerin",
    ziarraSoulJourney: "La Ziarra : Un Voyage de l'Âme",
    ziarraConclusion: "Plus qu'un simple déplacement physique, la ziarra est une migration intérieure vers la présence divine. Elle permet au disciple de se détacher du monde matériel pour se concentrer sur l'essentiel : la relation avec Allah et l'amour du Prophète (PSL).",
    
    // Common
    readMore: "En savoir plus",
    seeAll: "Voir tout",
    subscribe: "S'inscrire",
    search: "Rechercher...",
    learnMore: "En savoir plus",
    discover: "Découvrir",
    exploreGallery: "Explorer la Galerie",
    viewAllVideos: "Voir toutes les vidéos",
    noFeaturedVideos: "Aucune vidéo en vedette disponible",
    spiritualPath: "Sur la voie de la purification spirituelle",
    
    // Home
    heroTitle: "L'empreinte de Maodo",
    heroSubtitle: "",
    heroDescription: "Découvrez l'héritage spirituel d'El Hadji Malick Sy et les enseignements de la Tijaniyya",
    quoteOfDay: "Citation du Jour",
    upcomingEvents: "Événements à Venir",
    featuredVideos: "Vidéos en Vedette",
    welcomeMessage: "Bienvenue sur le site L'empreinte de Maodo !",
    exploreHistory: "Explorer l'Histoire",
    discoverContent: "Découvrez nos contenus les plus populaires et inspirants",
    aboutDescription: "Le Foyer Tidiane de Tivaouane est une confrérie soufie fondée par Cheikh El Hadj Malick Sy, un grand érudit et guide spirituel. Elle représente une voie de purification spirituelle et d'élévation de l'âme à travers le dhikr et les enseignements prophétiques.",
    
    // Newsletter
    stayInformed: "Restez Informé",
    newsletterDesc: "Inscrivez-vous pour recevoir les dates des événements et les actualités de Tivaouane",
    enterEmail: "Entrez votre adresse email",
    subscribing: "Inscription...",
    thankYou: "Merci pour votre inscription !",
    privacyNote: "Nous respectons votre vie privée. Désabonnement possible à tout moment.",
    subscribers: "Abonnés",
    frequency: "Fréquence",
    free: "Gratuit",
    
    // Footer
    allRightsReserved: "Tous droits réservés",
    quickLinks: "Liens Rapides",
    followUs: "Suivez-nous",
    aboutSite: "À propos du site",
    
    // Stats
    statsTitle: "Le Foyer Tidiane en Chiffres",
    pilgrims: "Pèlerins au Gamou",
    onlineFollowers: "Disciples en ligne",
    daysOfDevotion: "Jours de dévotion",
    countriesRepresented: "Pays représentés",
    
    // Pages
    pageNotFound: "Page non trouvée",
    backToHome: "Retour à l'accueil",
    
    // Maodo Page
    theFounder: "Le Fondateur",
    scholarSaint: "Érudit, Saint, Fondateur de la Zawiya de Tivaouane et Vivificateur de la Sunna du Prophète (PSL)",
    maodoIntro: "El Hadji Malick Sy, affectueusement appelé Maodo (terme wolof signifiant \"le Vénéré\"), fut l'un des plus grands érudits musulmans de l'Afrique de l'Ouest. Chef de la confrérie Tijaniyya au Sénégal, il transforma Tivaouane en un centre spirituel rayonnant dont l'influence perdure jusqu'à nos jours.",
    maodoBio: "Né en 1855 dans le village de Gaya au nord du Sénégal, il consacra sa vie entière à l'apprentissage, l'enseignement et la diffusion de l'Islam selon la voie du Prophète Muhammad (PSL). Son érudition exceptionnelle, sa piété exemplaire et sa sagesse firent de lui une référence incontournable pour des générations de musulmans.",
    maodoQuote: "Chez Maodo, la dualité l'emporte sur l'alternative : il fut à la fois homme de science et homme d'action, mystique et pragmatique, traditionaliste et moderniste.",
    historicPhotos: "Photos Historiques",
    portraitsOfMaodo: "Portraits de Maodo",
    lifePath: "Parcours de Vie",
    majorContributions: "Ses Contributions Majeures",
    literaryWorks: "Ses Œuvres Littéraires",
    literaryHeritage: "Maodo a laissé un héritage littéraire inestimable",
    viewAllWorks: "Voir tous les ouvrages",
    wordsOfWisdom: "Paroles de Sagesse",
    eternalLegacy: "Son Héritage Éternel",
    legacyText: "Aujourd'hui, plus d'un siècle après son rappel à Dieu, l'influence de Maodo continue de rayonner. La Tariqa Tijaniyya est devenue la principale confrérie soufie au Sénégal, et le Gamou de Tivaouane rassemble chaque année plus de 5 millions de fidèles. Ses enseignements, transmis par ses héritiers, continuent d'éclairer les cœurs et les esprits de millions de musulmans à travers le monde.",
    hisSuccessors: "Ses Héritiers",
    theGamou: "Le Gamou",
    mayAllahBePleasedWithHim: "Que Dieu soit satisfait de lui et le rende satisfait",
    
    // Timeline
    birth: "Naissance",
    birthDesc: "Naissance dans le quartier de Daw Fall à Gaya, département de Dagana, au nord du Sénégal.",
    quranMemorization: "Mémorisation du Coran",
    quranMemorizationDesc: "Mémorisation complète du Saint Coran en sept ans, démontrant une intelligence et une dévotion exceptionnelles.",
    islamicStudies: "Études islamiques",
    islamicStudiesDesc: "25 années d'études approfondies en fiqh maliki, théologie, exégèse et sciences islamiques dans différents centres.",
    saintLouisSettlement: "Installation à Saint-Louis",
    saintLouisSettlementDesc: "Installation à Saint-Louis pour enseigner. Il adopte le nom de Malick Fawade en hommage à sa pieuse mère.",
    hajjPilgrimage: "Pèlerinage à La Mecque",
    hajjPilgrimageDesc: "Accomplissement du Hajj à 31 ans. Séjour de deux ans à La Mecque, passage par Marseille et Alexandrie.",
    zawiyaNdar: "Construction de la Zawiya de Ndar",
    zawiyaNdarDesc: "Édification de la première zawiya à Saint-Louis (Ndar), centre d'enseignement et de spiritualité.",
    tivaouaneSettlement: "Installation à Tivaouane",
    tivaouaneSettlementDesc: "Sur invitation de Djibril Guèye, il s'établit définitivement à Tivaouane après un séjour à Ndiarndé.",
    zawiyaTivaouane: "Fondation de la Zawiya de Tivaouane",
    zawiyaTivaouaneDesc: "Création de la zawiya principale de Tivaouane et institution de la première célébration du Mawlid (Gamou).",
    returnToGod: "Rappel à Dieu",
    returnToGodDesc: "Le 27 juin 1922, El Hadji Malick Sy rejoint son Seigneur à Tivaouane, où il est inhumé.",
    
    // Contributions
    gamouFounder: "Fondateur du Gamou",
    gamouFounderDesc: "Institution de la première célébration organisée du Mawlid Nabi au Sénégal en 1902",
    schoolBuilder: "Bâtisseur d'écoles",
    schoolBuilderDesc: "Fondation de nombreuses écoles coraniques au Djolof et au Walo",
    tijaniyyaSpreader: "Diffuseur de la Tijaniyya",
    tijaniyyaSpreaderDesc: "Propagation de la Tariqa Tijaniyya, devenue la principale confrérie soufie au Sénégal",
    manOfPeace: "Homme de paix",
    manOfPeaceDesc: "Dialogue pacifique avec les colonisateurs plutôt que confrontation armée",
    prolificAuthor: "Auteur prolifique",
    prolificAuthorDesc: "Rédaction d'ouvrages majeurs sur la théologie, le soufisme et la sunna prophétique",
    sunnaReviver: "Vivificateur de la Sunna",
    sunnaReviverDesc: "Modèle achevé de piété, incarnant les enseignements du Prophète (PSL)",
    
    // Quotes context
    onAction: "Sur l'importance de l'action",
    onDivineKnowledge: "Sur la connaissance divine",
    onPropheticLove: "Sur l'amour prophétique",
    
    // Khalifes Page
    lineageOfHeirs: "La Lignée des Héritiers",
    heirsSubtitle: "Les Héritiers de Maodo : Gardiens de l'Héritage Spirituel",
    heirsIntro: "L'œuvre de Mawlaya El Hadji Malick Sy (rta) ne s'est pas éteinte avec lui en 1922. Elle a été portée par une lignée d'hommes d'exception : ses fils et ses disciples. Si la direction officielle de la confrérie (le Califat) a suivi une lignée précise, chaque héritier, qu'il ait accédé au trône de la Khadra ou non, a été un gardien vigilant du temple du savoir.",
    successionPrinciple: "",
    majorContributionsLabel: "Contributions Majeures :",
    currentKhalife: "Khalife Actuel",
    unbrokenChain: "Une Chaîne Spirituelle Ininterrompue",
    chainText: "De Maodo à nos jours, la transmission de la Baraka (grâce spirituelle) s'est poursuivie sans rupture. Chaque Khalife a été le maillon d'une chaîne qui remonte au Prophète Muhammad (PSL) à travers Cheikh Ahmed Tijani.",
    continuityGuarantee: "Cette continuité est le gage de l'authenticité de la voie et de la fidélité à l'enseignement originel.",
    mayAllahBePleasedWithThemAll: "Que Allah les agrée tous",
    
    // Khalifes titles
    firstKhalife: "Le Premier Khalife",
    multidimensionalScholar: "Le Savant Multidimensionnel",
    socialRegulator: "Le Régulateur Social",
    tirelessServant: "L'Infatigable Serviteur",
    ascetOfFass: "L'Ascète de Fass - Borom Fass",
    protectorOfKnowledge: "Le Protecteur du Savoir",
    multidimensionalVisionary: "Le Visionnaire Multidimensionnel",
    builderAndDiplomat: "Le Bâtisseur et Diplomate",
    currentGuide: "Le Guide Actuel",
    
    // Family Tree Page
    spiritualLineage: "Lignée Spirituelle",
    familyTreeTitle: "Arbre Généalogique",
    familyTreeSubtitle: "La descendance d'El Hadji Malick Sy et la succession des Khalifes",
    clickToExpand: "Cliquez sur un membre de la famille pour voir ses descendants",
    aboutThisTree: "À propos de cet arbre",
    treeDescription: "Cet arbre généalogique présente une vue simplifiée de la descendance d'El Hadji Malick Sy, en mettant l'accent sur la lignée des Khalifes et les figures majeures de la famille.",
    extendedFamily: "La famille de Maodo est très étendue, avec des centaines de descendants répartis à travers le Sénégal et le monde entier.",
    viewDetailedPage: "Voir la page détaillée des Héritiers",
    legend: "Légende",
    founder: "Fondateur (Maodo)",
    descendants: "Descendants",
    
    // Interactive Map Page
    sacredPlaces: "Lieux Saints",
    mapTitle: "Carte Interactive de Tivaouane",
    mapSubtitle: "Découvrez les lieux saints et historiques de la cité spirituelle",
    placesToDiscover: "Lieux à Découvrir",
    grandMosque: "Grande Mosquée",
    grandMosqueDesc: "Centre spirituel et lieu de rassemblement principal",
    mausoleum: "Mausolée de Maodo",
    mausoleumDesc: "Lieu de repos éternel d'El Hadji Malick Sy",
    mainZawiya: "Zawiya Principale",
    mainZawiyaDesc: "Centre d'enseignement et de spiritualité",
    library: "Bibliothèque Islamique",
    libraryDesc: "Conservation des manuscrits et ouvrages",
    
    // Contact Page
    contactUs: "Contactez-nous",
    contactSubtitle: "Nous sommes à votre écoute",
    yourName: "Votre nom",
    yourEmail: "Votre email",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer",
    sending: "Envoi en cours...",
    messageSent: "Message envoyé avec succès !",
    address: "Adresse",
    phone: "Téléphone",
    
    // Events
    ziarraGenerale: "Ziarra Générale 2025",
    gamou2025: "Gamou 2025",
    hadratoulJoumah: "Hadratoul Joumah",
    everyFriday: "Tous les vendredis",
    
    // Citations
    quote1: "La science sans la pratique est comme un arbre sans fruit.",
    quote2: "Celui qui connaît Dieu, son cœur trouve la paix.",
    quote3: "L'amour du Prophète (PSL) est la clé de tout bien.",
    quote4: "Le savoir est une lumière qui illumine le cœur du croyant.",
    quote5: "La patience dans l'épreuve est le signe de la foi sincère.",
    
    // École de Tivaouane Page
    ecoleTitle: "L'École de Tivaouane",
    ecoleSubtitle: "Former l'Homme Complet",
    popularUniversity: "Université Populaire",
    ecoleHeroDesc: "La méthode pédagogique unique d'El Hadji Malick Sy qui a révolutionné l'enseignement islamique en Afrique de l'Ouest",
    ecoleIntro1: "L'École de Tivaouane n'est pas une institution au sens moderne, mais un système d'enseignement vivant créé par El Hadji Malick Sy, qui visait à former des musulmans éclairés, à la fois savants et vertueux.",
    ecoleIntro2: "Dès son installation en 1902, Maodo établit une zawiya (école coranique) qui devint rapidement un centre d'attraction pour des milliers d'étudiants. Sa pédagogie se distinguait par son accessibilité : contrairement aux écoles élitistes de l'époque, Tivaouane accueillait tous les aspirants au savoir, riches ou pauvres, Wolofs ou Sérères, citadins ou ruraux.",
    maodoVision: "La vision de Maodo",
    maodoVisionQuote: "Le savoir religieux doit être accessible à tous. Un berger qui connaît son Seigneur vaut mieux qu'un érudit orgueilleux.",
    pedagogicalMethod: "La Méthode Pédagogique",
    integralTeaching: "Enseignement Intégral",
    integralTeachingDesc: "Combinaison harmonieuse entre sciences religieuses (Coran, Hadith, Fiqh) et sciences profanes (mathématiques, langues)",
    oralPedagogy: "Pédagogie Orale",
    oralPedagogyDesc: "Transmission directe du maître à l'élève, favorisant la mémorisation et la compréhension profonde",
    spiritualFormation: "Formation Spirituelle",
    spiritualFormationDesc: "Au-delà de la science, éducation du caractère (Akhlaq) et purification de l'âme (Tazkiyya)",
    guidingPrinciples: "Les Principes Directeurs",
    freeEducation: "La Gratuité de l'Enseignement",
    freeEducationDesc: "L'éducation à Tivaouane était entièrement gratuite. Les étudiants étaient nourris et logés par la communauté. Le savoir était considéré comme un bien sacré qui ne se monnaye pas.",
    scienceSpiritualityBalance: "L'Équilibre Science-Spiritualité",
    scienceSpiritualityBalanceDesc: "Maodo insistait sur le fait que la science sans spiritualité mène à l'orgueil, et la spiritualité sans science conduit à l'égarement. L'étudiant devait cultiver les deux simultanément.",
    communityService: "Le Service à la Communauté",
    communityServiceDesc: "Les étudiants étaient encouragés à mettre leur savoir au service de la société : enseigner aux enfants, conseiller les familles, arbitrer les conflits.",
    teachingCycles: "Les Cycles d'Enseignement",
    elementaryCycle: "Cycle Élémentaire",
    elementaryCycleDesc: "Apprentissage du Coran par cœur, initiation à la langue arabe, principes de base de l'Islam",
    middleCycle: "Cycle Moyen",
    middleCycleDesc: "Grammaire arabe (Nahw, Sarf), Fiqh, Hadith, introduction au Tafsir",
    superiorCycle: "Cycle Supérieur",
    superiorCycleDesc: "Spécialisation en Tafsir, Hadith, Fiqh approfondi, Usul al-Fiqh, Logique (Mantiq)",
    greatMasters: "Les Grands Maîtres de Tivaouane",
    greatMastersDesc: "L'École de Tivaouane a produit des sommités dans tous les domaines des sciences islamiques",
    specialties: "Spécialités",
    contribution: "Contribution",
    lastingLegacy: "Un Héritage qui Perdure",
    lastingLegacyDesc: "Aujourd'hui encore, des dizaines de daaras (écoles coraniques) perpétuent la méthode de Maodo à Tivaouane et dans tout le Sénégal. Des milliers d'étudiants y apprennent le Coran, la langue arabe et les sciences islamiques dans le respect de la tradition éducative tidiane.",
    activeDaaras: "Daaras actives",
    currentStudents: "Étudiants actuels",
    yearsOfHistory: "Ans d'histoire",
    seekKnowledge: "Cherchez la science du berceau jusqu'à la tombe",
    
    // CarteTivaouane Page
    sacredGeographyLabel: "Géographie Sacrée",
    interactiveMapTitle: "Carte Interactive de Tivaouane",
    discoverHolyPlaces: "Découvrez les lieux saints de la cité spirituelle",
    holyPlaces: "Lieux Saints",
    selectPlace: "Sélectionnez un lieu",
    selectPlaceDesc: "Cliquez sur un lieu dans la liste pour voir ses détails et obtenir l'itinéraire.",
    getDirections: "Obtenir l'itinéraire",
    legendTitle: "Légende",
    mosque: "Mosquée",
    mausoleumType: "Mausolée",
    zawiyaType: "Zawiya",
    eventPlace: "Lieu d'événement",
    residence: "Résidence",
    libraryType: "Bibliothèque",
    howToGetThere: "Comment se rendre à Tivaouane ?",
    fromDakar: "Depuis Dakar",
    fromDakarDesc: "~90 km (1h30 en voiture via l'autoroute A1)",
    fromThies: "Depuis Thiès",
    fromThiesDesc: "~20 km (30 min en voiture)",
    transport: "Transport",
    transportDesc: "Bus, taxis et cars rapides disponibles",
    openAllDay: "Ouverte 24h/24 pour les prières",
    accessibleDuringPrayer: "Accessible pendant les heures de prière",
    hadratoulJoumahTime: "Hadratoul Joumah : Tous les vendredis après Asr",
    usedDuringGamou: "Utilisé principalement lors du Gamou",
    visitsByAppointment: "Visites sur rendez-vous",
    libHours: "Lun-Sam : 9h-17h",
    
    // Gamou Page
    annualCelebration: "Célébration Annuelle",
    gamouTitle: "Le Gamou de Tivaouane",
    mawlidAnNabawi: "Maouloud an-Nabawi",
    gamouHeroDesc: "Le plus grand rassemblement spirituel d'Afrique de l'Ouest en l'honneur de la naissance du Prophète Muhammad (PSL)",
    gamouIntro1: "Le Gamou de Tivaouane est bien plus qu'une fête religieuse : c'est un moment de communion spirituelle intense, un pèlerinage annuel qui réaffirme l'amour des Tidiane pour le Prophète Muhammad (PSL) et leur attachement à son message.",
    gamouIntro2: "Institué par El Hadji Malick Sy au début du XXe siècle, le Gamou de Tivaouane est devenu le rendez-vous incontournable de la Tidjanidya sénégalaise et ouest-africaine. Chaque année, au 12e jour du mois de Rabi' al-Awwal, des millions de fidèles convergent vers la cité sainte.",
    gamouSpirit: "L'esprit du Gamou",
    gamouSpiritText: "Il ne s'agit pas seulement de commémorer une naissance, mais de raviver en chaque cœur l'amour du Prophète (PSL) et de renouveler son engagement sur la voie spirituelle.",
    gamouHistoryTitle: "Histoire du Gamou de Tivaouane",
    gamouHistory1: "La célébration du Maouloud (naissance du Prophète) n'était pas systématique au Sénégal avant l'arrivée d'El Hadji Malick Sy. C'est lui qui institutionnalisa cette pratique à Tivaouane dès le début du XXe siècle.",
    gamouHistory2: "La première célébration organisée fut modeste, mais elle gagna rapidement en ampleur. Maodo y voyait une opportunité d'éduquer les masses : les 10 jours précédant le Maouloud étaient consacrés à la récitation du Bourde (poème mystique) et à l'enseignement des valeurs prophétiques.",
    gamouHistory3: "Après la mort de Maodo en 1922, ses héritiers perpétuèrent la tradition. Le Gamou devint progressivement l'événement spirituel majeur du Sénégal, attirant des personnalités politiques, des intellectuels et surtout des millions de disciples.",
    celebrationProgram: "Le Déroulement des Célébrations",
    tenDaysOfBourde: "10 Jours de Bourde",
    tenDaysOfBourdeDesc: "Récitation du poème Al-Burda d'Al-Bousayri en l'honneur du Prophète (PSL), accompagnée de chants spirituels",
    nightlyTalks: "Causeries Nocturnes",
    nightlyTalksDesc: "Grands tafsirs et enseignements dispensés par les érudits durant les nuits précédant le Maouloud",
    massGathering: "Rassemblement Massif",
    massGatheringDesc: "Convergence de millions de fidèles venus de toute l'Afrique et du monde entier",
    mawlidNight: "Nuit du Maouloud",
    mawlidNightDesc: "Point culminant des célébrations avec la grande prière collective et les bénédictions",
    practicalInfo: "Informations Pratiques",
    gamouDate: "Nuit du jeudi 4 au vendredi 5 septembre 2025 (12 Rabi' al-Awwal)",
    mainLocation: "Lieu Principal",
    mainLocationDesc: "Grande Mosquée de Tivaouane et ses alentours (Champs de courses)",
    attendance: "Affluence",
    attendanceDesc: "Plus de 5 millions de pèlerins attendus chaque année",
    pilgrimAdvice: "Conseils aux Pèlerins",
    beforeDeparture: "Avant le Départ",
    onSite: "Sur Place",
    bookAccommodation: "Réserver son hébergement plusieurs semaines à l'avance",
    modestClothing: "Prévoir des vêtements adaptés (tenues modestes)",
    bringWird: "Se munir de son Wird et de son chapelet",
    followOrganizers: "Respecter l'ordre et la discipline des organisateurs",
    participateBourde: "Participer aux séances de Bourde et de dhikr",
    keepClean: "Préserver la propreté des lieux saints",
    appointmentWithEternity: "Un Rendez-vous avec l'Éternité",
    gamouConclusion: "Le Gamou de Tivaouane n'est pas qu'un rassemblement de masse. C'est un moment où le ciel et la terre se rejoignent, où les cœurs des fidèles vibrent à l'unisson dans l'amour du meilleur des hommes, Muhammad (PSL).",
    peaceAndBlessings: "Que la paix et les bénédictions d'Allah soient sur lui",
    
    // Ziarra Page
    ziarraTitle: "Les Ziarra Annuelles",
    spiritualPilgrimages: "Pèlerinages Spirituels",
    ziarraHeroDesc: "Les rendez-vous sacrés qui rythment la vie spirituelle des disciples tidiane",
    ziarraIntro1: "Les Ziarra (زيارة, visites) sont des pèlerinages périodiques que les disciples tidiane effectuent à Tivaouane pour se ressourcer spirituellement, renouveler leur allégeance et recevoir les bénédictions (Baraka) du Khalife.",
    ziarraIntro2: "Contrairement au Gamou qui est une célébration universelle du Maouloud, les Ziarra sont des moments plus intimes de connexion entre les disciples et leur guide spirituel. Elles permettent de maintenir vivant le lien (Râbita) qui unit chaque tidiane à la lignée de Maodo.",
    mainZiarras: "Les Principales Ziarra",
    ziarraGeneraleTitle: "Ziarra Générale 2025",
    ziarraGeneraleDate: "Dimanche 20 avril 2025",
    ziarraGeneraleDesc: "La plus importante des ziarra, créée en 1930 par Serigne Babacar Sy. Elle rassemble des centaines de milliers de disciples venus renouveler leur pacte spirituel (bay'a) avec le Khalife Serigne Babacar Sy Mansour.",
    ziarraMaodoTitle: "Ziarra de Maodo",
    ziarraMaodoDate: "Anniversaire du rappel à Dieu d'El Hadji Malick Sy (27 Jumada al-Thani)",
    ziarraMaodoDesc: "Pèlerinage commémoratif en l'honneur du fondateur de Tivaouane. Les disciples se recueillent sur sa tombe et lisent des poèmes en son honneur.",
    ziarraKhalifesTitle: "Ziarra des Khalifes",
    ziarraKhalifesDate: "Dates variables selon les khalifes",
    ziarraKhalifesDesc: "Commémorations des différents Khalifes héritiers de Maodo. Chaque khalife a sa propre journée de ziarra.",
    program: "Programme",
    spiritualSignificance: "Signification Spirituelle",
    pilgrimGuide: "Guide du Pèlerin",
    spiritualPreparation: "Préparation Spirituelle",
    logisticalPreparation: "Préparation Logistique",
    sincereIntention: "Formuler une intention sincère (Niya) avant le départ",
    spiritualPurification: "Se purifier spirituellement par le repentir",
    multiplyPrayers: "Multiplier les prières sur le Prophète (PSL) durant le voyage",
    bookInAdvance: "Réserver son hébergement à l'avance",
    modestComfortableClothing: "Prévoir des vêtements modestes et confortables",
    bringWirdChapelet: "Apporter son Wird et son chapelet",
    bringMoneyHadiya: "Se munir d'argent pour les dons (Hadiya)",
    followInstructions: "Respecter les consignes des organisateurs",
    participateCollectivePrayers: "Participer aux prières collectives",
    visitWithReflection: "Visiter les lieux saints avec recueillement",
    maintainCleanliness: "Maintenir la propreté des espaces publics",
    ziarraSoulJourney: "La Ziarra : Un Voyage de l'Âme",
    ziarraConclusion: "La ziarra n'est pas qu'un déplacement physique vers Tivaouane. C'est un voyage intérieur, une migration spirituelle (Hijra) où le disciple quitte ses préoccupations matérielles pour se rapprocher d'Allah à travers l'amour de son guide.",
    
    // Mediatheque Page
    mediathequeTitle: "Médiathèque",
    mediathequeSubtitle: "Explorez notre collection multimédia sur L'empreinte de Maodo",
    mediathequeIntro: "La médiathèque de Tivaouane rassemble une collection exhaustive de contenus audiovisuels, photographiques et écrits sur l'histoire, les enseignements et la vie spirituelle de la Tijaniyya. Notre objectif est de rendre accessible ce patrimoine au plus grand nombre.",
    videos: "Vidéos",
    videosDesc: "Conférences, enseignements et événements de Tivaouane",
    photoLibrary: "Photothèque",
    photoLibraryDesc: "Photos historiques et actuelles de la Grande Mosquée et des cérémonies",
    manuscripts: "Manuscrits",
    manuscriptsDesc: "Ouvrages numérisés d'El Hadji Malick Sy et autres érudits",
    audioArchives: "Archives Audio",
    audioArchivesDesc: "Causeries, tafsirs et chants spirituels enregistrés",
    recentVideos: "Vidéos Récentes",
    officialChannels: "Chaînes Officielles",
    followLiveEvents: "Suivez les événements de Tivaouane en direct",
    downloadableResources: "Ressources Téléchargeables",
    maodoWorksDigital: "Ouvrages de Maodo en format numérique",
    digitalLibrary: "Bibliothèque Numérique",
    maodoWorks: "Ouvrages de Maodo",
    maodoWorksDesc: "Kifâyat ar-Râghibîn, poèmes mystiques, correspondances et autres écrits d'El Hadji Malick Sy disponibles en téléchargement.",
    consultLibrary: "Consulter la bibliothèque",
    historicalArchives: "Archives Historiques",
    historicalArchivesDesc: "Photos anciennes, manuscrits, enregistrements audio et documents historiques préservant la mémoire de Tivaouane.",
    exploreArchives: "Explorer les archives",
    contributeMediatheque: "Contribuez à la Médiathèque",
    contributeDesc: "Vous possédez des documents, photos, enregistrements ou vidéos relatifs à Tivaouane ? Aidez-nous à enrichir notre collection pour les générations futures.",
    submitDocument: "Soumettre un Document",
    subscribeChannel: "S'abonner",
    views: "vues"
  },
  en: {
    // Navigation
    home: "Home",
    history: "History",
    teachings: "Teachings",
    events: "Events",
    archives: "Archives",
    media: "Media Library",
    contact: "Contact",
    origins: "The Origins",
    maodo: "Maodo (El Hadji Malick Sy)",
    heirsLineage: "Lineage of Heirs",
    familyTree: "Family Tree",
    sacredGeography: "Sacred Geography",
    interactiveMap: "Interactive Map",
    pillars: "Pillars of the Tariqa",
    school: "The School of Tivaouane",
    referenceWorks: "Reference Works",
    gamou: "The Gamou",
    annualZiarra: "Annual Ziarra",
    religiousCeremonies: "Religious Ceremonies",
    
    // Page Origines
    originesTitle: "The Origins",
    originesSubtitle: "From Fes to Tivaouane",
    originesHeroDesc: "The history of a Sufi path that has crossed centuries and continents",
    originesGenesisTitle: "The Genesis of the Tijaniyya",
    foundingEvent: "The founding event",
    foundingEventDesc: "In 1781, at the age of 44, Cheikh Ahmed Tijani received in a waking state (yaqdha) the spiritual visit of Prophet Muhammad (PBUH) who ordered him to found a new Sufi path and directly transmitted the Wird (daily litanies).",
    directTransmissionDesc: "This revelation marks the birth of a unique Tariqa in the history of Sufism: unlike other paths that rely on a chain (silsila) of masters going back to the Prophet, the Tijaniyya claims direct transmission, without human intermediary.",
    expansionChronology: "Chronology of Expansion",
    tariqaSpecificities: "The Specificities of the Tariqa",
    arrivalWestAfrica: "Arrival in West Africa",
    arrivalIntro: "The Tijaniyya arrived in West Africa at the beginning of the 19th century through several routes:",
    universalHeritage: "A Universal Heritage",
    universalHeritageDesc: "Today, the Tijaniyya has millions of disciples around the world, from Morocco to Nigeria, from Mauritania to Sudan. Tivaouane remains one of its most radiant spiritual centers, perpetuating the authentic teaching of Cheikh Ahmed Tijani through the lineage of Maodo.",
    
    // Page Géographie Sacrée
    holyCity: "Tivaouane, the Holy City",
    geographieHeroDesc: "Why Tivaouane became the nerve center of the Tijaniyya",
    tivaouaneTransformation: "Tivaouane: From Village to Spiritual Metropolis",
    whyTivaouane: "Why Tivaouane?",
    whyTivaouaneDesc: "Maodo's choice of Tivaouane was not by chance. Several strategic factors guided this decision:",
    distanceFromPower: "Distance from colonial power",
    distanceFromPowerDesc: "Unlike Saint-Louis, the colonial capital where he taught, Tivaouane offered more autonomy",
    centralPosition: "Central geographical position",
    centralPositionDesc: "Crossroads between several regions, facilitating the influx of disciples",
    fertileLand: "Fertile and peaceful land",
    fertileLandDesc: "Conducive to study and meditation",
    rapidTransformation: "Within a few years, Tivaouane transformed into an intellectual and spiritual hub. Students flocked from all over Senegal, Gambia, Mauritania and even Guinea to study with Maodo.",
    emblematicPlaces: "Emblematic Places",
    cityOrganization: "The Organization of the City",
    cityOrgIntro: "Tivaouane is organized today around three main poles:",
    demographicMetamorphosis: "A Demographic Metamorphosis",
    uniqueCase: "This transformation makes Tivaouane a unique case in West Africa: a city whose identity and prosperity are entirely linked to its spiritual dimension.",
    moreThanaCity: "Tivaouane: More than a City, a State of Mind",
    moreThanaDesc: "Tivaouane is not just a geographical place. It is a spiritual project, a realized utopia where knowledge and piety coexist, where disciples from all horizons meet in the love of the Prophet (PBUH) and the teaching of Maodo.",
    cityOfLight: "City of Light",
    
    // Page Ziarra
    ziarraTitle: "Annual Ziarras",
    spiritualPilgrimages: "Spiritual Pilgrimages",
    ziarraHeroDesc: "The sacred appointments that rhythm the spiritual life of Tidiane disciples",
    ziarraIntro1: "The Ziarras (زيارة, visits) are periodic pilgrimages that Tidiane disciples make to Tivaouane to recharge spiritually, renew their allegiance and receive the blessings (Baraka) of the Khalife.",
    ziarraIntro2: "Unlike the Gamou which is a universal celebration of the Mawlid, the Ziarras are more intimate moments of connection between disciples and their spiritual guide. They help maintain the living link (Râbita) that unites each Tidiane to the lineage of Maodo.",
    mainZiarras: "The Main Ziarras",
    program: "Program",
    spiritualSignificance: "Spiritual Significance",
    pilgrimGuide: "Pilgrim's Guide",
    ziarraSoulJourney: "The Ziarra: A Journey of the Soul",
    ziarraConclusion: "The ziarra is not just a physical journey to Tivaouane. It is an inner journey, a spiritual migration (Hijra) where the disciple leaves material concerns to draw closer to Allah through the love of their guide.",
    ziarraGeneraleTitle: "General Ziarra 2025",
    ziarraGeneraleDate: "Sunday, April 20, 2025",
    ziarraGeneraleDesc: "The most important ziarra, created in 1930 by Serigne Babacar Sy. It gathers hundreds of thousands of disciples who come to renew their spiritual pact (bay'a) with Khalife Serigne Babacar Sy Mansour.",
    ziarraMaodoTitle: "Ziarra of Maodo",
    ziarraMaodoDate: "Anniversary of El Hadji Malick Sy's return to God (27 Jumada al-Thani)",
    ziarraMaodoDesc: "Commemorative pilgrimage in honor of the founder of Tivaouane. Disciples gather at his tomb and recite poems in his honor.",
    ziarraKhalifesTitle: "Ziarra of the Khalifes",
    ziarraKhalifesDate: "Variable dates depending on the khalifes",
    ziarraKhalifesDesc: "Commemorations of the various Khalifes who succeeded Maodo. Each khalife has their own ziarra day.",
    spiritualPreparation: "Spiritual Preparation",
    logisticalPreparation: "Logistical Preparation",
    sincereIntention: "Formulate a sincere intention (Niya) before departure",
    spiritualPurification: "Purify yourself spiritually through repentance",
    multiplyPrayers: "Multiply prayers upon the Prophet (PBUH) during the journey",
    bookInAdvance: "Book your accommodation in advance",
    modestComfortableClothing: "Bring modest and comfortable clothing",
    bringWirdChapelet: "Bring your Wird and your prayer beads",
    bringMoneyHadiya: "Bring money for donations (Hadiya)",
    followInstructions: "Follow the organizers' instructions",
    participateCollectivePrayers: "Participate in collective prayers",
    visitWithReflection: "Visit holy places with reflection",
    maintainCleanliness: "Maintain cleanliness of public spaces",
    
    // Common
    readMore: "Read more",
    seeAll: "See all",
    subscribe: "Subscribe",
    search: "Search...",
    learnMore: "Learn more",
    discover: "Discover",
    exploreGallery: "Explore Gallery",
    viewAllVideos: "View all videos",
    noFeaturedVideos: "No featured videos available",
    spiritualPath: "On the path of spiritual purification",
    
    // Home
    heroTitle: "The Legacy of Maodo",
    heroSubtitle: "",
    heroDescription: "Discover the spiritual heritage of El Hadji Malick Sy and the teachings of the Tijaniyya",
    quoteOfDay: "Quote of the Day",
    upcomingEvents: "Upcoming Events",
    featuredVideos: "Featured Videos",
    welcomeMessage: "Welcome to The Legacy of Maodo website!",
    exploreHistory: "Explore History",
    discoverContent: "Discover our most popular and inspiring content",
    aboutDescription: "The Tidiane Foyer of Tivaouane is a Sufi brotherhood founded by Sheikh El Hadj Malick Sy, a great scholar and spiritual guide. It represents a path of spiritual purification and elevation of the soul through dhikr and prophetic teachings.",
    
    // Newsletter
    stayInformed: "Stay Informed",
    newsletterDesc: "Subscribe to receive event dates and news from Tivaouane",
    enterEmail: "Enter your email address",
    subscribing: "Subscribing...",
    thankYou: "Thank you for subscribing!",
    privacyNote: "We respect your privacy. Unsubscribe anytime.",
    subscribers: "Subscribers",
    frequency: "Frequency",
    free: "Free",
    
    // Footer
    allRightsReserved: "All rights reserved",
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    aboutSite: "About this site",
    
    // Stats
    statsTitle: "The Tidiane Foyer in Numbers",
    pilgrims: "Pilgrims at the Gamou",
    onlineFollowers: "Online followers",
    daysOfDevotion: "Days of devotion",
    countriesRepresented: "Countries represented",
    
    // Pages
    pageNotFound: "Page not found",
    backToHome: "Back to home",
    
    // Maodo Page
    theFounder: "The Founder",
    scholarSaint: "Scholar, Saint, Founder of the Zawiya of Tivaouane and Reviver of the Sunna of the Prophet (PBUH)",
    maodoIntro: "El Hadji Malick Sy, affectionately called Maodo (a Wolof term meaning \"the Venerated\"), was one of the greatest Muslim scholars of West Africa. Head of the Tijaniyya brotherhood in Senegal, he transformed Tivaouane into a radiant spiritual center whose influence endures to this day.",
    maodoBio: "Born in 1855 in the village of Gaya in northern Senegal, he devoted his entire life to learning, teaching, and spreading Islam according to the way of Prophet Muhammad (PBUH). His exceptional scholarship, exemplary piety, and wisdom made him an indispensable reference for generations of Muslims.",
    maodoQuote: "In Maodo, duality prevails over the alternative: he was at once a man of science and action, mystic and pragmatic, traditionalist and modernist.",
    historicPhotos: "Historic Photos",
    portraitsOfMaodo: "Portraits of Maodo",
    lifePath: "Life Journey",
    majorContributions: "His Major Contributions",
    literaryWorks: "His Literary Works",
    literaryHeritage: "Maodo left an invaluable literary heritage",
    viewAllWorks: "View all works",
    wordsOfWisdom: "Words of Wisdom",
    eternalLegacy: "His Eternal Legacy",
    legacyText: "Today, more than a century after his return to God, Maodo's influence continues to radiate. The Tijaniyya Tariqa has become the main Sufi brotherhood in Senegal, and the Gamou of Tivaouane gathers more than 5 million faithful every year. His teachings, transmitted by his heirs, continue to enlighten the hearts and minds of millions of Muslims around the world.",
    hisSuccessors: "His Heirs",
    theGamou: "The Gamou",
    mayAllahBePleasedWithHim: "May God be pleased with him and make him satisfied",
    
    // Timeline
    birth: "Birth",
    birthDesc: "Birth in the Daw Fall neighborhood of Gaya, Dagana department, northern Senegal.",
    quranMemorization: "Quran Memorization",
    quranMemorizationDesc: "Complete memorization of the Holy Quran in seven years, demonstrating exceptional intelligence and devotion.",
    islamicStudies: "Islamic Studies",
    islamicStudiesDesc: "25 years of in-depth studies in Maliki fiqh, theology, exegesis, and Islamic sciences in various centers.",
    saintLouisSettlement: "Settlement in Saint-Louis",
    saintLouisSettlementDesc: "Settlement in Saint-Louis to teach. He adopted the name Malick Fawade in tribute to his pious mother.",
    hajjPilgrimage: "Pilgrimage to Mecca",
    hajjPilgrimageDesc: "Completion of Hajj at age 31. Two-year stay in Mecca, passing through Marseille and Alexandria.",
    zawiyaNdar: "Construction of Zawiya of Ndar",
    zawiyaNdarDesc: "Building of the first zawiya in Saint-Louis (Ndar), center of teaching and spirituality.",
    tivaouaneSettlement: "Settlement in Tivaouane",
    tivaouaneSettlementDesc: "At the invitation of Djibril Guèye, he permanently settled in Tivaouane after a stay in Ndiarndé.",
    zawiyaTivaouane: "Foundation of Zawiya of Tivaouane",
    zawiyaTivaouaneDesc: "Creation of the main zawiya of Tivaouane and institution of the first Mawlid (Gamou) celebration.",
    returnToGod: "Return to God",
    returnToGodDesc: "On June 27, 1922, El Hadji Malick Sy returned to his Lord in Tivaouane, where he is buried.",
    
    // Contributions
    gamouFounder: "Founder of the Gamou",
    gamouFounderDesc: "Institution of the first organized celebration of Mawlid Nabi in Senegal in 1902",
    schoolBuilder: "School Builder",
    schoolBuilderDesc: "Foundation of numerous Quranic schools in Djolof and Walo",
    tijaniyyaSpreader: "Spreader of Tijaniyya",
    tijaniyyaSpreaderDesc: "Propagation of the Tijaniyya Tariqa, which became the main Sufi brotherhood in Senegal",
    manOfPeace: "Man of Peace",
    manOfPeaceDesc: "Peaceful dialogue with colonizers rather than armed confrontation",
    prolificAuthor: "Prolific Author",
    prolificAuthorDesc: "Writing of major works on theology, Sufism, and prophetic sunna",
    sunnaReviver: "Reviver of the Sunna",
    sunnaReviverDesc: "Perfect model of piety, embodying the teachings of the Prophet (PBUH)",
    
    // Quotes context
    onAction: "On the importance of action",
    onDivineKnowledge: "On divine knowledge",
    onPropheticLove: "On prophetic love",
    
    // Khalifes Page
    lineageOfHeirs: "The Lineage of Heirs",
    heirsSubtitle: "The Heirs of Maodo: Guardians of the Spiritual Heritage",
    heirsIntro: "The work of Mawlaya El Hadji Malick Sy (rta) did not end with him in 1922. It was carried on by a lineage of exceptional men: his sons and his disciples. While the official leadership of the brotherhood (the Caliphate) followed a specific line, each heir, whether or not they acceded to the throne of Khadra, was a vigilant guardian of the temple of knowledge.",
    successionPrinciple: "",
    majorContributionsLabel: "Major Contributions:",
    currentKhalife: "Current Khalife",
    unbrokenChain: "An Unbroken Spiritual Chain",
    chainText: "From Maodo to the present day, the transmission of Baraka (spiritual grace) has continued without interruption. Each Khalife has been a link in a chain that goes back to Prophet Muhammad (PBUH) through Sheikh Ahmed Tijani.",
    continuityGuarantee: "This continuity is the guarantee of the authenticity of the path and faithfulness to the original teaching.",
    mayAllahBePleasedWithThemAll: "May Allah be pleased with them all",
    
    // Khalifes titles
    firstKhalife: "The First Khalife",
    multidimensionalScholar: "The Multidimensional Scholar",
    socialRegulator: "The Social Regulator",
    tirelessServant: "The Tireless Servant",
    ascetOfFass: "The Ascetic of Fass - Borom Fass",
    protectorOfKnowledge: "The Protector of Knowledge",
    multidimensionalVisionary: "The Multidimensional Visionary",
    builderAndDiplomat: "The Builder and Diplomat",
    currentGuide: "The Current Guide",
    
    // Family Tree Page
    spiritualLineage: "Spiritual Lineage",
    familyTreeTitle: "Family Tree",
    familyTreeSubtitle: "The descendants of El Hadji Malick Sy and the succession of Khalifes",
    clickToExpand: "Click on a family member to see their descendants",
    aboutThisTree: "About this tree",
    treeDescription: "This family tree presents a simplified view of the descendants of El Hadji Malick Sy, focusing on the lineage of Khalifes and major figures of the family.",
    extendedFamily: "Maodo's family is very extensive, with hundreds of descendants spread across Senegal and the entire world.",
    viewDetailedPage: "View the detailed Heirs page",
    legend: "Legend",
    founder: "Founder (Maodo)",
    descendants: "Descendants",
    
    // Interactive Map Page
    sacredPlaces: "Sacred Places",
    mapTitle: "Interactive Map of Tivaouane",
    mapSubtitle: "Discover the holy and historic sites of the spiritual city",
    placesToDiscover: "Places to Discover",
    grandMosque: "Grand Mosque",
    grandMosqueDesc: "Spiritual center and main gathering place",
    mausoleum: "Mausoleum of Maodo",
    mausoleumDesc: "Eternal resting place of El Hadji Malick Sy",
    mainZawiya: "Main Zawiya",
    mainZawiyaDesc: "Center of teaching and spirituality",
    library: "Islamic Library",
    libraryDesc: "Preservation of manuscripts and works",
    
    // Contact Page
    contactUs: "Contact Us",
    contactSubtitle: "We are here to help",
    yourName: "Your name",
    yourEmail: "Your email",
    subject: "Subject",
    message: "Message",
    send: "Send",
    sending: "Sending...",
    messageSent: "Message sent successfully!",
    address: "Address",
    phone: "Phone",
    
    // Events
    ziarraGenerale: "General Ziarra 2025",
    gamou2025: "Gamou 2025",
    hadratoulJoumah: "Hadratoul Joumah",
    everyFriday: "Every Friday",
    
    // Citations
    quote1: "Knowledge without practice is like a tree without fruit.",
    quote2: "He who knows God, his heart finds peace.",
    quote3: "Love for the Prophet (PBUH) is the key to all goodness.",
    quote4: "Knowledge is a light that illuminates the heart of the believer.",
    quote5: "Patience in trial is the sign of sincere faith.",
    
    // École de Tivaouane Page
    ecoleTitle: "The School of Tivaouane",
    ecoleSubtitle: "Forming the Complete Person",
    popularUniversity: "Popular University",
    ecoleHeroDesc: "El Hadji Malick Sy's unique pedagogical method that revolutionized Islamic education in West Africa",
    ecoleIntro1: "The School of Tivaouane is not an institution in the modern sense, but a living teaching system created by El Hadji Malick Sy, which aimed to train enlightened Muslims, both learned and virtuous.",
    ecoleIntro2: "From his settlement in 1902, Maodo established a zawiya (Quranic school) that quickly became a center of attraction for thousands of students. His pedagogy was distinguished by its accessibility: unlike the elitist schools of the time, Tivaouane welcomed all seekers of knowledge, rich or poor, Wolof or Serer, urban or rural.",
    maodoVision: "Maodo's Vision",
    maodoVisionQuote: "Religious knowledge must be accessible to all. A shepherd who knows his Lord is worth more than a proud scholar.",
    pedagogicalMethod: "The Pedagogical Method",
    integralTeaching: "Integral Teaching",
    integralTeachingDesc: "Harmonious combination of religious sciences (Quran, Hadith, Fiqh) and secular sciences (mathematics, languages)",
    oralPedagogy: "Oral Pedagogy",
    oralPedagogyDesc: "Direct transmission from master to student, promoting memorization and deep understanding",
    spiritualFormation: "Spiritual Formation",
    spiritualFormationDesc: "Beyond science, education of character (Akhlaq) and purification of the soul (Tazkiyya)",
    guidingPrinciples: "Guiding Principles",
    freeEducation: "Free Education",
    freeEducationDesc: "Education in Tivaouane was entirely free. Students were fed and housed by the community. Knowledge was considered a sacred good that cannot be sold.",
    scienceSpiritualityBalance: "Science-Spirituality Balance",
    scienceSpiritualityBalanceDesc: "Maodo insisted that science without spirituality leads to pride, and spirituality without science leads to error. The student had to cultivate both simultaneously.",
    communityService: "Community Service",
    communityServiceDesc: "Students were encouraged to put their knowledge at the service of society: teaching children, advising families, arbitrating conflicts.",
    teachingCycles: "Teaching Cycles",
    elementaryCycle: "Elementary Cycle",
    elementaryCycleDesc: "Learning the Quran by heart, introduction to Arabic, basic principles of Islam",
    middleCycle: "Middle Cycle",
    middleCycleDesc: "Arabic grammar (Nahw, Sarf), Fiqh, Hadith, introduction to Tafsir",
    superiorCycle: "Superior Cycle",
    superiorCycleDesc: "Specialization in Tafsir, Hadith, advanced Fiqh, Usul al-Fiqh, Logic (Mantiq)",
    greatMasters: "The Great Masters of Tivaouane",
    greatMastersDesc: "The School of Tivaouane produced authorities in all fields of Islamic sciences",
    specialties: "Specialties",
    contribution: "Contribution",
    lastingLegacy: "A Lasting Legacy",
    lastingLegacyDesc: "Today still, dozens of daaras (Quranic schools) perpetuate Maodo's method in Tivaouane and throughout Senegal. Thousands of students learn the Quran, Arabic language and Islamic sciences in respect of the Tidiane educational tradition.",
    activeDaaras: "Active Daaras",
    currentStudents: "Current Students",
    yearsOfHistory: "Years of History",
    seekKnowledge: "Seek knowledge from the cradle to the grave",
    
    // CarteTivaouane Page
    sacredGeographyLabel: "Sacred Geography",
    interactiveMapTitle: "Interactive Map of Tivaouane",
    discoverHolyPlaces: "Discover the holy places of the spiritual city",
    holyPlaces: "Holy Places",
    selectPlace: "Select a place",
    selectPlaceDesc: "Click on a place in the list to see its details and get directions.",
    getDirections: "Get directions",
    legendTitle: "Legend",
    mosque: "Mosque",
    mausoleumType: "Mausoleum",
    zawiyaType: "Zawiya",
    eventPlace: "Event venue",
    residence: "Residence",
    libraryType: "Library",
    howToGetThere: "How to get to Tivaouane?",
    fromDakar: "From Dakar",
    fromDakarDesc: "~90 km (1h30 by car via A1 highway)",
    fromThies: "From Thiès",
    fromThiesDesc: "~20 km (30 min by car)",
    transport: "Transport",
    transportDesc: "Buses, taxis and minibuses available",
    openAllDay: "Open 24/7 for prayers",
    accessibleDuringPrayer: "Accessible during prayer times",
    hadratoulJoumahTime: "Hadratoul Joumah: Every Friday after Asr",
    usedDuringGamou: "Mainly used during the Gamou",
    visitsByAppointment: "Visits by appointment",
    libHours: "Mon-Sat: 9am-5pm",
    
    // Gamou Page
    annualCelebration: "Annual Celebration",
    gamouTitle: "The Gamou of Tivaouane",
    mawlidAnNabawi: "Mawlid an-Nabawi",
    gamouHeroDesc: "The largest spiritual gathering in West Africa in honor of the birth of Prophet Muhammad (PBUH)",
    gamouIntro1: "The Gamou of Tivaouane is much more than a religious festival: it is a moment of intense spiritual communion, an annual pilgrimage that reaffirms the Tidiane's love for Prophet Muhammad (PBUH) and their attachment to his message.",
    gamouIntro2: "Instituted by El Hadji Malick Sy at the beginning of the 20th century, the Gamou of Tivaouane has become the essential gathering of Senegalese and West African Tijaniyya. Every year, on the 12th day of the month of Rabi' al-Awwal, millions of faithful converge towards the holy city.",
    gamouSpirit: "The Spirit of the Gamou",
    gamouSpiritText: "It is not only about commemorating a birth, but about reviving in every heart the love of the Prophet (PBUH) and renewing one's commitment to the spiritual path.",
    gamouHistoryTitle: "History of the Gamou of Tivaouane",
    gamouHistory1: "The celebration of the Mawlid (birth of the Prophet) was not systematic in Senegal before the arrival of El Hadji Malick Sy. It was he who institutionalized this practice in Tivaouane at the beginning of the 20th century.",
    gamouHistory2: "The first organized celebration was modest, but it quickly grew in scope. Maodo saw it as an opportunity to educate the masses: the 10 days preceding the Mawlid were devoted to the recitation of the Bourde (mystical poem) and the teaching of prophetic values.",
    gamouHistory3: "After Maodo's death in 1922, his heirs perpetuated the tradition. The Gamou gradually became Senegal's major spiritual event, attracting political figures, intellectuals and above all millions of disciples.",
    celebrationProgram: "The Celebration Program",
    tenDaysOfBourde: "10 Days of Bourde",
    tenDaysOfBourdeDesc: "Recitation of Al-Bousayri's Al-Burda poem in honor of the Prophet (PBUH), accompanied by spiritual songs",
    nightlyTalks: "Nightly Talks",
    nightlyTalksDesc: "Great tafsirs and teachings given by scholars during the nights preceding the Mawlid",
    massGathering: "Mass Gathering",
    massGatheringDesc: "Convergence of millions of faithful from all over Africa and the entire world",
    mawlidNight: "Mawlid Night",
    mawlidNightDesc: "Culmination of celebrations with the great collective prayer and blessings",
    practicalInfo: "Practical Information",
    gamouDate: "Night of Thursday September 4 to Friday September 5, 2025 (12 Rabi' al-Awwal)",
    mainLocation: "Main Location",
    mainLocationDesc: "Grand Mosque of Tivaouane and surroundings (Racecourse)",
    attendance: "Attendance",
    attendanceDesc: "More than 5 million pilgrims expected every year",
    pilgrimAdvice: "Advice for Pilgrims",
    beforeDeparture: "Before Departure",
    onSite: "On Site",
    bookAccommodation: "Book accommodation several weeks in advance",
    modestClothing: "Plan appropriate clothing (modest attire)",
    bringWird: "Bring your Wird and prayer beads",
    followOrganizers: "Respect the order and discipline of the organizers",
    participateBourde: "Participate in Bourde and dhikr sessions",
    keepClean: "Preserve the cleanliness of holy places",
    appointmentWithEternity: "An Appointment with Eternity",
    gamouConclusion: "The Gamou of Tivaouane is not just a mass gathering. It is a moment when heaven and earth meet, when the hearts of the faithful vibrate in unison in the love of the best of men, Muhammad (PBUH).",
    peaceAndBlessings: "May the peace and blessings of Allah be upon him",
    
    // Ziarra Page
    ziarraTitle: "Annual Ziarras",
    spiritualPilgrimages: "Spiritual Pilgrimages",
    ziarraHeroDesc: "The sacred gatherings that punctuate the spiritual life of Tidiane disciples",
    ziarraIntro1: "Ziarras (زيارة, visits) are periodic pilgrimages that Tidiane disciples make to Tivaouane to recharge spiritually, renew their allegiance and receive the blessings (Baraka) of the Khalife.",
    ziarraIntro2: "Unlike the Gamou which is a universal celebration of the Mawlid, Ziarras are more intimate moments of connection between disciples and their spiritual guide. They help maintain the bond (Râbita) that unites each Tidiane to Maodo's lineage.",
    mainZiarras: "Main Ziarras",
    ziarraGeneraleTitle: "General Ziarra 2025",
    ziarraGeneraleDate: "Sunday April 20, 2025",
    ziarraGeneraleDesc: "The most important ziarra, created in 1930 by Serigne Babacar Sy. It brings together hundreds of thousands of disciples who come to renew their spiritual pact (bay'a) with Khalife Serigne Babacar Sy Mansour.",
    ziarraMaodoTitle: "Ziarra of Maodo",
    ziarraMaodoDate: "Anniversary of El Hadji Malick Sy's return to God (27 Jumada al-Thani)",
    ziarraMaodoDesc: "Commemorative pilgrimage in honor of the founder of Tivaouane. Disciples gather at his tomb and recite poems in his honor.",
    ziarraKhalifesTitle: "Ziarra of the Khalifes",
    ziarraKhalifesDate: "Variable dates depending on the khalifes",
    ziarraKhalifesDesc: "Commemorations of the various Khalifes who succeeded Maodo. Each khalife has their own ziarra day.",
    program: "Program",
    spiritualSignificance: "Spiritual Significance",
    pilgrimGuide: "Pilgrim's Guide",
    spiritualPreparation: "Spiritual Preparation",
    logisticalPreparation: "Logistical Preparation",
    sincereIntention: "Formulate a sincere intention (Niya) before departure",
    spiritualPurification: "Purify yourself spiritually through repentance",
    multiplyPrayers: "Multiply prayers upon the Prophet (PBUH) during the journey",
    bookInAdvance: "Book accommodation in advance",
    modestComfortableClothing: "Plan modest and comfortable clothing",
    bringWirdChapelet: "Bring your Wird and prayer beads",
    bringMoneyHadiya: "Bring money for donations (Hadiya)",
    followInstructions: "Follow the organizers' instructions",
    participateCollectivePrayers: "Participate in collective prayers",
    visitWithReflection: "Visit holy places with reflection",
    maintainCleanliness: "Maintain cleanliness of public spaces",
    ziarraSoulJourney: "Ziarra: A Journey of the Soul",
    ziarraConclusion: "Ziarra is not just a physical trip to Tivaouane. It is an inner journey, a spiritual migration (Hijra) where the disciple leaves their material concerns to draw closer to Allah through love for their guide.",
    
    // Mediatheque Page
    mediathequeTitle: "Media Library",
    mediathequeSubtitle: "Explore our multimedia collection on the Tidiane Tariqa",
    mediathequeIntro: "Tivaouane's media library brings together a comprehensive collection of audiovisual, photographic and written content on the history, teachings and spiritual life of the Tidiane Tariqa. Our goal is to make this heritage accessible to as many people as possible.",
    videos: "Videos",
    videosDesc: "Conferences, teachings and events from Tivaouane",
    photoLibrary: "Photo Library",
    photoLibraryDesc: "Historical and current photos of the Grand Mosque and ceremonies",
    manuscripts: "Manuscripts",
    manuscriptsDesc: "Digitized works of El Hadji Malick Sy and other scholars",
    audioArchives: "Audio Archives",
    audioArchivesDesc: "Recorded talks, tafsirs and spiritual songs",
    recentVideos: "Recent Videos",
    officialChannels: "Official Channels",
    followLiveEvents: "Follow Tivaouane events live",
    downloadableResources: "Downloadable Resources",
    maodoWorksDigital: "Maodo's works in digital format",
    digitalLibrary: "Digital Library",
    maodoWorks: "Works of Maodo",
    maodoWorksDesc: "Kifâyat ar-Râghibîn, mystical poems, correspondences and other writings by El Hadji Malick Sy available for download.",
    consultLibrary: "Consult the library",
    historicalArchives: "Historical Archives",
    historicalArchivesDesc: "Old photos, manuscripts, audio recordings and historical documents preserving the memory of Tivaouane.",
    exploreArchives: "Explore archives",
    contributeMediatheque: "Contribute to the Media Library",
    contributeDesc: "Do you have documents, photos, recordings or videos related to Tivaouane? Help us enrich our collection for future generations.",
    submitDocument: "Submit a Document",
    subscribeChannel: "Subscribe",
    views: "views"
  },
  ar: {
    // Navigation
    home: "الرئيسية",
    history: "التاريخ",
    teachings: "التعاليم",
    events: "الفعاليات",
    archives: "الأرشيف",
    media: "المكتبة",
    contact: "اتصل بنا",
    origins: "الأصول",
    maodo: "مودو (الحاج مالك سي)",
    heirsLineage: "سلالة الورثة",
    familyTree: "شجرة العائلة",
    sacredGeography: "الجغرافيا المقدسة",
    interactiveMap: "الخريطة التفاعلية",
    pillars: "أركان الطريقة",
    school: "مدرسة تيفاوان",
    referenceWorks: "المؤلفات المرجعية",
    gamou: "المولد",
    annualZiarra: "الزيارة السنوية",
    religiousCeremonies: "المراسم الدينية",
    
    // Page Origines
    originesTitle: "الأصول",
    originesSubtitle: "من فاس إلى تيفاوان",
    originesHeroDesc: "تاريخ طريق صوفي عبر القرون والقارات",
    originesGenesisTitle: "نشأة الطريقة التجانية",
    foundingEvent: "الحدث المؤسس",
    foundingEventDesc: "في عام 1781، في سن 44، تلقى الشيخ أحمد التجاني في حالة يقظة زيارة روحية من النبي محمد (ص) الذي أمره بتأسيس طريقة صوفية جديدة ونقل إليه الورد مباشرة.",
    directTransmissionDesc: "يمثل هذا الكشف ولادة طريقة فريدة في تاريخ التصوف: على عكس الطرق الأخرى التي تعتمد على سلسلة من المشايخ تعود إلى النبي، تدعي التجانية نقلاً مباشراً، بدون وسيط بشري.",
    expansionChronology: "تسلسل التوسع الزمني",
    tariqaSpecificities: "خصوصيات الطريقة",
    arrivalWestAfrica: "الوصول إلى غرب أفريقيا",
    arrivalIntro: "وصلت الطريقة التجانية إلى غرب أفريقيا في بداية القرن التاسع عشر عبر عدة طرق:",
    universalHeritage: "إرث عالمي",
    universalHeritageDesc: "اليوم، تضم الطريقة التجانية ملايين المريدين حول العالم، من المغرب إلى نيجيريا، ومن موريتانيا إلى السودان. تظل تيفاوان أحد أكثر مراكزها الروحية إشعاعاً، تخلد تعاليم الشيخ أحمد التجاني الأصيلة عبر سلالة مودو.",
    
    // Page Géographie Sacrée
    holyCity: "تيفاوان، المدينة المقدسة",
    geographieHeroDesc: "لماذا أصبحت تيفاوان المركز العصبي للتجانية",
    tivaouaneTransformation: "تيفاوان: من قرية إلى عاصمة روحية",
    whyTivaouane: "لماذا تيفاوان؟",
    whyTivaouaneDesc: "لم يكن اختيار مودو لتيفاوان صدفة. عدة عوامل استراتيجية وجهت هذا القرار:",
    distanceFromPower: "البعد عن السلطة الاستعمارية",
    distanceFromPowerDesc: "على عكس سان لويس، العاصمة الاستعمارية حيث كان يدرّس، وفرت تيفاوان استقلالية أكبر",
    centralPosition: "الموقع الجغرافي المركزي",
    centralPositionDesc: "ملتقى طرق بين عدة مناطق، مما سهّل تدفق المريدين",
    fertileLand: "أرض خصبة وهادئة",
    fertileLandDesc: "مناسبة للدراسة والتأمل",
    rapidTransformation: "في غضون سنوات قليلة، تحولت تيفاوان إلى مركز فكري وروحي. توافد الطلاب من جميع أنحاء السنغال وغامبيا وموريتانيا وحتى غينيا للدراسة عند مودو.",
    emblematicPlaces: "الأماكن الرمزية",
    cityOrganization: "تنظيم المدينة",
    cityOrgIntro: "تنتظم تيفاوان اليوم حول ثلاثة محاور رئيسية:",
    demographicMetamorphosis: "تحول ديموغرافي",
    uniqueCase: "هذا التحول يجعل من تيفاوان حالة فريدة في غرب أفريقيا: مدينة ترتبط هويتها وازدهارها بالكامل ببعدها الروحي.",
    moreThanaCity: "تيفاوان: أكثر من مدينة، حالة ذهنية",
    moreThanaDesc: "تيفاوان ليست مجرد مكان جغرافي. إنها مشروع روحي، يوتوبيا محققة حيث يتعايش العلم والتقوى، حيث يلتقي المريدون من كل الآفاق في حب النبي (ص) وتعاليم مودو.",
    cityOfLight: "مدينة النور",
    
    // Page Ziarra
    ziarraTitle: "الزيارات السنوية",
    spiritualPilgrimages: "الحج الروحي",
    ziarraHeroDesc: "المواعيد المقدسة التي تنظم الحياة الروحية لمريدي التجانية",
    ziarraIntro1: "الزيارات هي حج دوري يقوم به مريدو التجانية إلى تيفاوان للتجدد الروحي وتجديد البيعة والحصول على بركة الخليفة.",
    ziarraIntro2: "على عكس المولد الذي هو احتفال عالمي، الزيارات هي لحظات أكثر حميمية للتواصل بين المريدين ومرشدهم الروحي. تساعد على الحفاظ على الرابطة الحية التي تجمع كل تجاني بسلالة مودو.",
    mainZiarras: "الزيارات الرئيسية",
    program: "البرنامج",
    spiritualSignificance: "الأهمية الروحية",
    pilgrimGuide: "دليل الزائر",
    ziarraSoulJourney: "الزيارة: رحلة الروح",
    ziarraConclusion: "الزيارة ليست مجرد رحلة جسدية إلى تيفاوان. إنها رحلة داخلية، هجرة روحية حيث يترك المريد همومه المادية ليقترب من الله من خلال حب مرشده.",
    ziarraGeneraleTitle: "الزيارة العامة 2025",
    ziarraGeneraleDate: "الأحد 20 أبريل 2025",
    ziarraGeneraleDesc: "أهم زيارة، أسسها سرين باباكار سي عام 1930. تجمع مئات الآلاف من المريدين لتجديد عهدهم الروحي (البيعة) مع الخليفة سرين باباكار سي منصور.",
    ziarraMaodoTitle: "زيارة مودو",
    ziarraMaodoDate: "ذكرى رحيل الحاج مالك سي (27 جمادى الثانية)",
    ziarraMaodoDesc: "حج تذكاري تكريماً لمؤسس تيفاوان. يجتمع المريدون عند قبره ويقرأون القصائد تكريماً له.",
    ziarraKhalifesTitle: "زيارات الخلفاء",
    ziarraKhalifesDate: "تواريخ متغيرة حسب الخلفاء",
    ziarraKhalifesDesc: "إحياء ذكرى مختلف الخلفاء الذين خلفوا مودو. لكل خليفة يوم زيارته الخاص.",
    spiritualPreparation: "الإعداد الروحي",
    logisticalPreparation: "الإعداد اللوجستي",
    sincereIntention: "صياغة نية صادقة قبل السفر",
    spiritualPurification: "التطهر روحياً بالتوبة",
    multiplyPrayers: "الإكثار من الصلاة على النبي (ص) أثناء الرحلة",
    bookInAdvance: "حجز الإقامة مسبقاً",
    modestComfortableClothing: "إحضار ملابس محتشمة ومريحة",
    bringWirdChapelet: "إحضار الورد والسبحة",
    bringMoneyHadiya: "إحضار المال للتبرعات (الهدية)",
    followInstructions: "اتباع تعليمات المنظمين",
    participateCollectivePrayers: "المشاركة في الصلوات الجماعية",
    visitWithReflection: "زيارة الأماكن المقدسة بتأمل",
    maintainCleanliness: "الحفاظ على نظافة الأماكن العامة",
    
    // Common
    readMore: "اقرأ المزيد",
    seeAll: "عرض الكل",
    subscribe: "اشترك",
    search: "بحث...",
    learnMore: "اعرف المزيد",
    discover: "اكتشف",
    exploreGallery: "استكشف المعرض",
    viewAllVideos: "عرض جميع الفيديوهات",
    noFeaturedVideos: "لا تتوفر فيديوهات مميزة",
    spiritualPath: "على طريق التزكية الروحية",
    
    // Home
    heroTitle: "بصمة تيفاوان",
    heroSubtitle: "في الطريقة التجانية",
    heroDescription: "اكتشف الإرث الروحي للشيخ الحاج مالك سي وتعاليم الطريقة التجانية",
    quoteOfDay: "اقتباس اليوم",
    upcomingEvents: "الفعاليات القادمة",
    featuredVideos: "فيديوهات مميزة",
    welcomeMessage: "مرحبا بكم في موقع بصمة مودو!",
    exploreHistory: "استكشف التاريخ",
    discoverContent: "اكتشف محتوانا الأكثر شعبية وإلهاماً",
    aboutDescription: "مركز التجانية في تيفاوان هو طريقة صوفية أسسها الشيخ الحاج مالك سي، العالم الكبير والمرشد الروحي. وهي تمثل طريق التزكية الروحية والارتقاء بالنفس من خلال الذكر والتعاليم النبوية.",
    
    // Newsletter
    stayInformed: "ابق على اطلاع",
    newsletterDesc: "اشترك لتلقي تواريخ الفعاليات وأخبار تيفاوان",
    enterEmail: "أدخل بريدك الإلكتروني",
    subscribing: "جاري التسجيل...",
    thankYou: "شكرا لاشتراكك!",
    privacyNote: "نحن نحترم خصوصيتك. يمكنك إلغاء الاشتراك في أي وقت.",
    subscribers: "المشتركون",
    frequency: "التكرار",
    free: "مجاني",
    
    // Footer
    allRightsReserved: "جميع الحقوق محفوظة",
    quickLinks: "روابط سريعة",
    followUs: "تابعنا",
    aboutSite: "عن الموقع",
    
    // Stats
    statsTitle: "الطريقة التجانية بالأرقام",
    pilgrims: "حجاج المولد",
    onlineFollowers: "المتابعون عبر الإنترنت",
    daysOfDevotion: "أيام العبادة",
    countriesRepresented: "الدول الممثلة",
    
    // Pages
    pageNotFound: "الصفحة غير موجودة",
    backToHome: "العودة للرئيسية",
    
    // Maodo Page
    theFounder: "المؤسس",
    scholarSaint: "عالم، ولي، مؤسس زاوية تيفاوان ومحيي سنة النبي (ص)",
    maodoIntro: "الحاج مالك سي، الملقب بحب مودو (كلمة ولوفية تعني \"المبجل\")، كان أحد أعظم علماء المسلمين في غرب أفريقيا. رئيس الطريقة التجانية في السنغال، حول تيفاوان إلى مركز روحي مشع لا يزال تأثيره مستمرا حتى اليوم.",
    maodoBio: "ولد عام 1855 في قرية غايا شمال السنغال، كرس حياته كلها للتعلم والتدريس ونشر الإسلام وفق سنة النبي محمد (ص). جعلته علمه الاستثنائي وتقواه المثالي وحكمته مرجعا لا غنى عنه لأجيال من المسلمين.",
    maodoQuote: "في مودو، تسود الثنائية على البديل: كان في آن واحد رجل علم وعمل، صوفي وعملي، تقليدي وحداثي.",
    historicPhotos: "صور تاريخية",
    portraitsOfMaodo: "صور مودو",
    lifePath: "مسيرة الحياة",
    majorContributions: "إسهاماته الكبرى",
    literaryWorks: "مؤلفاته الأدبية",
    literaryHeritage: "ترك مودو إرثا أدبيا لا يقدر بثمن",
    viewAllWorks: "عرض جميع المؤلفات",
    wordsOfWisdom: "كلمات الحكمة",
    eternalLegacy: "إرثه الخالد",
    legacyText: "اليوم، بعد أكثر من قرن من رحيله إلى الله، لا يزال تأثير مودو يشع. أصبحت الطريقة التجانية الطريقة الصوفية الرئيسية في السنغال، ويجمع المولد في تيفاوان أكثر من 5 ملايين مؤمن كل عام. تعاليمه، التي نقلها خلفاؤه، تواصل إنارة قلوب وعقول ملايين المسلمين حول العالم.",
    hisSuccessors: "خلفاؤه",
    theGamou: "المولد",
    mayAllahBePleasedWithHim: "رضي الله عنه وأرضاه",
    
    // Timeline
    birth: "الميلاد",
    birthDesc: "ولد في حي داو فال بغايا، محافظة داغانا، شمال السنغال.",
    quranMemorization: "حفظ القرآن",
    quranMemorizationDesc: "حفظ القرآن الكريم كاملا في سبع سنوات، مما يدل على ذكاء وتفان استثنائيين.",
    islamicStudies: "الدراسات الإسلامية",
    islamicStudiesDesc: "25 عاما من الدراسات المعمقة في الفقه المالكي والعقيدة والتفسير والعلوم الإسلامية في مراكز مختلفة.",
    saintLouisSettlement: "الاستقرار في سان لويس",
    saintLouisSettlementDesc: "استقر في سان لويس للتدريس. اتخذ اسم مالك فواد تكريما لوالدته التقية.",
    hajjPilgrimage: "الحج إلى مكة",
    hajjPilgrimageDesc: "أداء الحج في سن 31 عاما. إقامة لمدة عامين في مكة، مرورا بمرسيليا والإسكندرية.",
    zawiyaNdar: "بناء زاوية ندار",
    zawiyaNdarDesc: "بناء أول زاوية في سان لويس (ندار)، مركز للتعليم والروحانية.",
    tivaouaneSettlement: "الاستقرار في تيفاوان",
    tivaouaneSettlementDesc: "بدعوة من جبريل غي، استقر نهائيا في تيفاوان بعد إقامة في نديارندي.",
    zawiyaTivaouane: "تأسيس زاوية تيفاوان",
    zawiyaTivaouaneDesc: "إنشاء الزاوية الرئيسية في تيفاوان وإقامة أول احتفال بالمولد النبوي (القمو).",
    returnToGod: "الرحيل إلى الله",
    returnToGodDesc: "في 27 يونيو 1922، عاد الحاج مالك سي إلى ربه في تيفاوان، حيث دفن.",
    
    // Contributions
    gamouFounder: "مؤسس المولد",
    gamouFounderDesc: "إقامة أول احتفال منظم بالمولد النبوي في السنغال عام 1902",
    schoolBuilder: "باني المدارس",
    schoolBuilderDesc: "تأسيس العديد من المدارس القرآنية في جولوف ووالو",
    tijaniyyaSpreader: "ناشر التجانية",
    tijaniyyaSpreaderDesc: "نشر الطريقة التجانية التي أصبحت الطريقة الصوفية الرئيسية في السنغال",
    manOfPeace: "رجل السلام",
    manOfPeaceDesc: "الحوار السلمي مع المستعمرين بدلا من المواجهة المسلحة",
    prolificAuthor: "مؤلف غزير الإنتاج",
    prolificAuthorDesc: "تأليف أعمال كبرى في العقيدة والتصوف والسنة النبوية",
    sunnaReviver: "محيي السنة",
    sunnaReviverDesc: "نموذج كامل للتقوى، مجسدا تعاليم النبي (ص)",
    
    // Quotes context
    onAction: "عن أهمية العمل",
    onDivineKnowledge: "عن المعرفة الإلهية",
    onPropheticLove: "عن حب النبي",
    
    // Khalifes Page
    lineageOfHeirs: "سلالة الورثة",
    heirsSubtitle: "خلفاء مودو: حراس الإرث الروحي",
    heirsIntro: "منذ رحيل الحاج مالك سي إلى الله عام 1922، تعاقب عدة خلفاء على رأس الطريقة التجانية في تيفاوان. كل واحد منهم أضاف لبنة للبناء، مساهما في نشر تعاليم مودو عبر الزمان والمكان.",
    successionPrinciple: "",
    majorContributionsLabel: "الإسهامات الكبرى:",
    currentKhalife: "الخليفة الحالي",
    unbrokenChain: "سلسلة روحية متصلة",
    chainText: "من مودو إلى يومنا هذا، استمر نقل البركة (النعمة الروحية) دون انقطاع. كل خليفة كان حلقة في سلسلة تعود إلى النبي محمد (ص) عبر الشيخ أحمد التجاني.",
    continuityGuarantee: "هذه الاستمرارية ضمان لأصالة الطريق والوفاء للتعليم الأصلي.",
    mayAllahBePleasedWithThemAll: "رضي الله عنهم أجمعين",
    
    // Khalifes titles
    firstKhalife: "الخليفة الأول",
    multidimensionalScholar: "العالم متعدد الأبعاد",
    socialRegulator: "المنظم الاجتماعي",
    tirelessServant: "الخادم الدؤوب",
    ascetOfFass: "زاهد فاس - بوروم فاس",
    protectorOfKnowledge: "حامي المعرفة",
    multidimensionalVisionary: "الرؤيوي متعدد الأبعاد",
    builderAndDiplomat: "الباني والدبلوماسي",
    currentGuide: "المرشد الحالي",
    
    // Family Tree Page
    spiritualLineage: "السلالة الروحية",
    familyTreeTitle: "شجرة العائلة",
    familyTreeSubtitle: "ذرية الحاج مالك سي وتعاقب الخلفاء",
    clickToExpand: "انقر على أحد أفراد العائلة لرؤية ذريته",
    aboutThisTree: "عن هذه الشجرة",
    treeDescription: "تقدم شجرة العائلة هذه عرضا مبسطا لذرية الحاج مالك سي، مع التركيز على سلالة الخلفاء والشخصيات البارزة في العائلة.",
    extendedFamily: "عائلة مودو واسعة جدا، مع مئات الأحفاد المنتشرين في السنغال والعالم بأسره.",
    viewDetailedPage: "عرض صفحة الورثة المفصلة",
    legend: "المفتاح",
    founder: "المؤسس (مودو)",
    descendants: "الذرية",
    
    // Interactive Map Page
    sacredPlaces: "الأماكن المقدسة",
    mapTitle: "الخريطة التفاعلية لتيفاوان",
    mapSubtitle: "اكتشف الأماكن المقدسة والتاريخية للمدينة الروحية",
    placesToDiscover: "أماكن للاستكشاف",
    grandMosque: "المسجد الكبير",
    grandMosqueDesc: "المركز الروحي ومكان التجمع الرئيسي",
    mausoleum: "ضريح مودو",
    mausoleumDesc: "مثوى الحاج مالك سي الأخير",
    mainZawiya: "الزاوية الرئيسية",
    mainZawiyaDesc: "مركز التعليم والروحانية",
    library: "المكتبة الإسلامية",
    libraryDesc: "حفظ المخطوطات والمؤلفات",
    
    // Contact Page
    contactUs: "اتصل بنا",
    contactSubtitle: "نحن هنا لمساعدتك",
    yourName: "اسمك",
    yourEmail: "بريدك الإلكتروني",
    subject: "الموضوع",
    message: "الرسالة",
    send: "إرسال",
    sending: "جاري الإرسال...",
    messageSent: "تم إرسال الرسالة بنجاح!",
    address: "العنوان",
    phone: "الهاتف",
    
    // Events
    ziarraGenerale: "الزيارة العامة 2025",
    gamou2025: "المولد 2025",
    hadratoulJoumah: "حضرة الجمعة",
    everyFriday: "كل جمعة",
    
    // Citations
    quote1: "العلم بلا عمل كالشجرة بلا ثمر.",
    quote2: "من عرف الله سكن قلبه.",
    quote3: "حب النبي (ص) مفتاح كل خير.",
    quote4: "العلم نور يضيء قلب المؤمن.",
    quote5: "الصبر على البلاء علامة الإيمان الصادق.",
    
    // École de Tivaouane Page
    ecoleTitle: "مدرسة تيفاوان",
    ecoleSubtitle: "تكوين الإنسان الكامل",
    popularUniversity: "الجامعة الشعبية",
    ecoleHeroDesc: "المنهج التعليمي الفريد للحاج مالك سي الذي أحدث ثورة في التعليم الإسلامي في غرب أفريقيا",
    ecoleIntro1: "مدرسة تيفاوان ليست مؤسسة بالمعنى الحديث، بل هي نظام تعليمي حي أنشأه الحاج مالك سي، هدفه تكوين مسلمين مستنيرين، علماء وفضلاء في آن واحد.",
    ecoleIntro2: "منذ استقراره عام 1902، أسس مودو زاوية (مدرسة قرآنية) سرعان ما أصبحت مركز جذب لآلاف الطلاب. تميزت طريقته التعليمية بسهولة الوصول إليها: على عكس المدارس النخبوية في ذلك الوقت، كانت تيفاوان تستقبل جميع طالبي العلم، أغنياء وفقراء، ولوف وسرير، حضريين وريفيين.",
    maodoVision: "رؤية مودو",
    maodoVisionQuote: "يجب أن يكون العلم الديني في متناول الجميع. راعٍ يعرف ربه خير من عالم متكبر.",
    pedagogicalMethod: "المنهج التعليمي",
    integralTeaching: "التعليم الشامل",
    integralTeachingDesc: "الجمع المتناغم بين العلوم الدينية (القرآن، الحديث، الفقه) والعلوم الدنيوية (الرياضيات، اللغات)",
    oralPedagogy: "التعليم الشفهي",
    oralPedagogyDesc: "النقل المباشر من المعلم إلى الطالب، مما يعزز الحفظ والفهم العميق",
    spiritualFormation: "التكوين الروحي",
    spiritualFormationDesc: "ما وراء العلم، تربية الخلق وتزكية النفس",
    guidingPrinciples: "المبادئ التوجيهية",
    freeEducation: "مجانية التعليم",
    freeEducationDesc: "كان التعليم في تيفاوان مجانياً بالكامل. كان الطلاب يُطعمون ويُأوون من قبل المجتمع. كان العلم يُعتبر خيراً مقدساً لا يُباع.",
    scienceSpiritualityBalance: "التوازن بين العلم والروحانية",
    scienceSpiritualityBalanceDesc: "أكد مودو على أن العلم بدون روحانية يؤدي إلى الكبر، والروحانية بدون علم تؤدي إلى الضلال. كان على الطالب أن يزرع الاثنين معاً.",
    communityService: "خدمة المجتمع",
    communityServiceDesc: "كان الطلاب يُشجعون على وضع علمهم في خدمة المجتمع: تعليم الأطفال، نصح العائلات، فض النزاعات.",
    teachingCycles: "دورات التعليم",
    elementaryCycle: "الدورة الابتدائية",
    elementaryCycleDesc: "حفظ القرآن الكريم، التمهيد للغة العربية، مبادئ الإسلام الأساسية",
    middleCycle: "الدورة المتوسطة",
    middleCycleDesc: "النحو والصرف، الفقه، الحديث، مقدمة في التفسير",
    superiorCycle: "الدورة العليا",
    superiorCycleDesc: "التخصص في التفسير، الحديث، الفقه المعمق، أصول الفقه، المنطق",
    greatMasters: "أكابر علماء تيفاوان",
    greatMastersDesc: "أنتجت مدرسة تيفاوان علماء بارزين في جميع مجالات العلوم الإسلامية",
    specialties: "التخصصات",
    contribution: "المساهمة",
    lastingLegacy: "إرث دائم",
    lastingLegacyDesc: "حتى اليوم، تواصل عشرات الدارات (المدارس القرآنية) منهج مودو في تيفاوان وجميع أنحاء السنغال. يتعلم آلاف الطلاب القرآن واللغة العربية والعلوم الإسلامية مع احترام التقاليد التعليمية التجانية.",
    activeDaaras: "دارات نشطة",
    currentStudents: "طلاب حاليون",
    yearsOfHistory: "سنة من التاريخ",
    seekKnowledge: "اطلبوا العلم من المهد إلى اللحد",
    
    // CarteTivaouane Page
    sacredGeographyLabel: "الجغرافيا المقدسة",
    interactiveMapTitle: "الخريطة التفاعلية لتيفاوان",
    discoverHolyPlaces: "اكتشف الأماكن المقدسة للمدينة الروحية",
    holyPlaces: "الأماكن المقدسة",
    selectPlace: "اختر مكاناً",
    selectPlaceDesc: "انقر على مكان في القائمة لرؤية تفاصيله والحصول على الاتجاهات.",
    getDirections: "احصل على الاتجاهات",
    legendTitle: "الدليل",
    mosque: "مسجد",
    mausoleumType: "ضريح",
    zawiyaType: "زاوية",
    eventPlace: "مكان الفعاليات",
    residence: "إقامة",
    libraryType: "مكتبة",
    howToGetThere: "كيف تصل إلى تيفاوان؟",
    fromDakar: "من داكار",
    fromDakarDesc: "~90 كم (ساعة ونصف بالسيارة عبر الطريق السريع A1)",
    fromThies: "من تييس",
    fromThiesDesc: "~20 كم (30 دقيقة بالسيارة)",
    transport: "المواصلات",
    transportDesc: "حافلات وسيارات أجرة ومركبات صغيرة متاحة",
    openAllDay: "مفتوح 24/7 للصلاة",
    accessibleDuringPrayer: "متاح أثناء أوقات الصلاة",
    hadratoulJoumahTime: "حضرة الجمعة: كل جمعة بعد العصر",
    usedDuringGamou: "يستخدم بشكل رئيسي أثناء المولد",
    visitsByAppointment: "الزيارات بموعد مسبق",
    libHours: "الإثنين-السبت: 9 صباحاً - 5 مساءً",
    
    // Gamou Page
    annualCelebration: "الاحتفال السنوي",
    gamouTitle: "مولد تيفاوان",
    mawlidAnNabawi: "المولد النبوي",
    gamouHeroDesc: "أكبر تجمع روحي في غرب أفريقيا تكريماً لمولد النبي محمد (ص)",
    gamouIntro1: "مولد تيفاوان هو أكثر من مجرد عيد ديني: إنه لحظة من التواصل الروحي المكثف، حج سنوي يؤكد حب التجانيين للنبي محمد (ص) وتمسكهم برسالته.",
    gamouIntro2: "أنشأه الحاج مالك سي في بداية القرن العشرين، وأصبح مولد تيفاوان الموعد الأساسي للتجانية السنغالية وغرب الأفريقية. كل عام، في اليوم الثاني عشر من شهر ربيع الأول، يتوافد الملايين من المؤمنين نحو المدينة المقدسة.",
    gamouSpirit: "روح المولد",
    gamouSpiritText: "لا يتعلق الأمر فقط بإحياء ذكرى ميلاد، بل بإعادة إحياء حب النبي (ص) في كل قلب وتجديد الالتزام بالطريق الروحي.",
    gamouHistoryTitle: "تاريخ مولد تيفاوان",
    gamouHistory1: "لم يكن الاحتفال بالمولد (مولد النبي) منتظماً في السنغال قبل وصول الحاج مالك سي. هو من أسس هذه الممارسة في تيفاوان في بداية القرن العشرين.",
    gamouHistory2: "كان الاحتفال الأول المنظم متواضعاً، لكنه سرعان ما اكتسب زخماً. رأى فيه مودو فرصة لتعليم الجماهير: كُرست الأيام العشرة السابقة للمولد لتلاوة البردة (القصيدة الصوفية) وتعليم القيم النبوية.",
    gamouHistory3: "بعد وفاة مودو عام 1922، واصل خلفاؤه التقليد. أصبح المولد تدريجياً الحدث الروحي الأكبر في السنغال، حيث يجذب الشخصيات السياسية والمثقفين وقبل كل شيء ملايين المريدين.",
    celebrationProgram: "برنامج الاحتفالات",
    tenDaysOfBourde: "عشرة أيام من البردة",
    tenDaysOfBourdeDesc: "تلاوة قصيدة البردة للبوصيري تكريماً للنبي (ص)، مصحوبة بالأناشيد الروحية",
    nightlyTalks: "المحاضرات الليلية",
    nightlyTalksDesc: "تفاسير كبرى ودروس يلقيها العلماء خلال الليالي السابقة للمولد",
    massGathering: "التجمع الجماهيري",
    massGatheringDesc: "توافد الملايين من المؤمنين من جميع أنحاء أفريقيا والعالم بأسره",
    mawlidNight: "ليلة المولد",
    mawlidNightDesc: "ذروة الاحتفالات مع الصلاة الجماعية الكبرى والبركات",
    practicalInfo: "معلومات عملية",
    gamouDate: "ليلة الخميس 4 إلى الجمعة 5 سبتمبر 2025 (12 ربيع الأول)",
    mainLocation: "المكان الرئيسي",
    mainLocationDesc: "المسجد الكبير في تيفاوان والمناطق المحيطة (ساحة السباق)",
    attendance: "الحضور",
    attendanceDesc: "أكثر من 5 ملايين حاج متوقع كل عام",
    pilgrimAdvice: "نصائح للحجاج",
    beforeDeparture: "قبل المغادرة",
    onSite: "في الموقع",
    bookAccommodation: "حجز الإقامة قبل عدة أسابيع",
    modestClothing: "تحضير ملابس مناسبة (لباس محتشم)",
    bringWird: "إحضار الورد والسبحة",
    followOrganizers: "احترام نظام وانضباط المنظمين",
    participateBourde: "المشاركة في جلسات البردة والذكر",
    keepClean: "الحفاظ على نظافة الأماكن المقدسة",
    appointmentWithEternity: "موعد مع الخلود",
    gamouConclusion: "مولد تيفاوان ليس مجرد تجمع جماهيري. إنه لحظة تلتقي فيها السماء والأرض، حيث تنبض قلوب المؤمنين بانسجام في حب خير البشر، محمد (ص).",
    peaceAndBlessings: "صلى الله عليه وسلم",
    
    // Ziarra Page
    ziarraTitle: "الزيارات السنوية",
    spiritualPilgrimages: "الحج الروحي",
    ziarraHeroDesc: "المواعيد المقدسة التي تنظم الحياة الروحية لمريدي التجانية",
    ziarraIntro1: "الزيارات هي حج دوري يقوم به مريدو التجانية إلى تيفاوان للتغذية الروحية وتجديد البيعة والحصول على بركات الخليفة.",
    ziarraIntro2: "على عكس المولد الذي هو احتفال عالمي، الزيارات هي لحظات أكثر حميمية للتواصل بين المريدين ومرشدهم الروحي. تساعد في الحفاظ على الرابطة التي توحد كل تجاني بسلسلة مودو.",
    mainZiarras: "الزيارات الرئيسية",
    ziarraGeneraleTitle: "الزيارة العامة 2025",
    ziarraGeneraleDate: "الأحد 20 أبريل 2025",
    ziarraGeneraleDesc: "أهم زيارة، أنشأها سرين باباكار سي عام 1930. تجمع مئات الآلاف من المريدين الذين يأتون لتجديد عهدهم الروحي (البيعة) مع الخليفة سرين باباكار سي منصور.",
    ziarraMaodoTitle: "زيارة مودو",
    ziarraMaodoDate: "ذكرى رحيل الحاج مالك سي إلى الله (27 جمادى الثانية)",
    ziarraMaodoDesc: "حج تذكاري تكريماً لمؤسس تيفاوان. يتجمع المريدون عند قبره ويقرأون القصائد تكريماً له.",
    ziarraKhalifesTitle: "زيارة الخلفاء",
    ziarraKhalifesDate: "تواريخ متغيرة حسب الخلفاء",
    ziarraKhalifesDesc: "إحياء ذكرى مختلف الخلفاء الذين خلفوا مودو. لكل خليفة يوم زيارته الخاص.",
    program: "البرنامج",
    spiritualSignificance: "الأهمية الروحية",
    pilgrimGuide: "دليل الحاج",
    spiritualPreparation: "الإعداد الروحي",
    logisticalPreparation: "الإعداد اللوجستي",
    sincereIntention: "صياغة نية صادقة قبل المغادرة",
    spiritualPurification: "التطهر روحياً بالتوبة",
    multiplyPrayers: "الإكثار من الصلاة على النبي (ص) أثناء الرحلة",
    bookInAdvance: "حجز الإقامة مسبقاً",
    modestComfortableClothing: "تحضير ملابس محتشمة ومريحة",
    bringWirdChapelet: "إحضار الورد والسبحة",
    bringMoneyHadiya: "إحضار المال للتبرعات (الهدية)",
    followInstructions: "اتباع تعليمات المنظمين",
    participateCollectivePrayers: "المشاركة في الصلوات الجماعية",
    visitWithReflection: "زيارة الأماكن المقدسة بتأمل",
    maintainCleanliness: "الحفاظ على نظافة الأماكن العامة",
    ziarraSoulJourney: "الزيارة: رحلة الروح",
    ziarraConclusion: "الزيارة ليست مجرد انتقال جسدي إلى تيفاوان. إنها رحلة داخلية، هجرة روحية حيث يترك المريد همومه المادية ليقترب من الله من خلال حب مرشده.",
    
    // Mediatheque Page
    mediathequeTitle: "المكتبة الإعلامية",
    mediathequeSubtitle: "استكشف مجموعتنا متعددة الوسائط عن الطريقة التجانية",
    mediathequeIntro: "تجمع مكتبة تيفاوان الإعلامية مجموعة شاملة من المحتويات السمعية والبصرية والمصورة والمكتوبة عن تاريخ وتعاليم والحياة الروحية للطريقة التجانية. هدفنا هو جعل هذا التراث في متناول أكبر عدد ممكن.",
    videos: "فيديوهات",
    videosDesc: "محاضرات ودروس وفعاليات من تيفاوان",
    photoLibrary: "مكتبة الصور",
    photoLibraryDesc: "صور تاريخية وحالية للمسجد الكبير والاحتفالات",
    manuscripts: "المخطوطات",
    manuscriptsDesc: "أعمال رقمية للحاج مالك سي وعلماء آخرين",
    audioArchives: "الأرشيف الصوتي",
    audioArchivesDesc: "محاضرات وتفاسير وأناشيد روحية مسجلة",
    recentVideos: "فيديوهات حديثة",
    officialChannels: "القنوات الرسمية",
    followLiveEvents: "تابع فعاليات تيفاوان مباشرة",
    downloadableResources: "موارد للتحميل",
    maodoWorksDigital: "أعمال مودو بصيغة رقمية",
    digitalLibrary: "المكتبة الرقمية",
    maodoWorks: "مؤلفات مودو",
    maodoWorksDesc: "كفاية الراغبين والقصائد الصوفية والمراسلات وكتابات أخرى للحاج مالك سي متاحة للتحميل.",
    consultLibrary: "استشر المكتبة",
    historicalArchives: "الأرشيف التاريخي",
    historicalArchivesDesc: "صور قديمة ومخطوطات وتسجيلات صوتية ووثائق تاريخية تحافظ على ذاكرة تيفاوان.",
    exploreArchives: "استكشف الأرشيف",
    contributeMediatheque: "ساهم في المكتبة الإعلامية",
    contributeDesc: "هل تمتلك وثائق أو صور أو تسجيلات أو فيديوهات متعلقة بتيفاوان؟ ساعدنا في إثراء مجموعتنا للأجيال القادمة.",
    submitDocument: "تقديم وثيقة",
    subscribeChannel: "اشترك",
    views: "مشاهدات"
  },
  wo: {
    // Navigation - Wolof
    home: "Ndakaaru",
    history: "Taariix",
    teachings: "Jàng",
    events: "Mbir yi",
    archives: "Dëgg yi",
    media: "Bidiyo yi",
    contact: "Jokkoo",
    origins: "Ndoorte yi",
    maodo: "Maodo (El Hadji Maalik Si)",
    heirsLineage: "Warisaay yi",
    familyTree: "Garab njàmbaar",
    sacredGeography: "Suuf bu sell",
    interactiveMap: "Kart bi",
    pillars: "Tënk yi",
    school: "Daara Tiwaawaan",
    referenceWorks: "Téere yi",
    gamou: "Gamou gi",
    annualZiarra: "Ziarra yi",
    religiousCeremonies: "Bëgg-bëgg diine yi",
    
    // Page Origines
    originesTitle: "Ndoorte yi",
    originesSubtitle: "Ci Fès ba Tiwaawaan",
    originesHeroDesc: "Taariix yoon wu sell wu tëral at yi ak kontinan yi",
    originesGenesisTitle: "Njëkk Tariqa Tijaan",
    foundingEvent: "Mbir buy tëkki",
    foundingEventDesc: "Ci 1781, am na 44 at, Cheikh Ahmed Tijani jot na ci yaqdha (yeengo) ziaarata ruuhi Yonent Muhammad (YWS) ku ko digal tëkki yoon wu sell wu bees te jox ko Wird bi.",
    directTransmissionDesc: "Kàshf bii mooy juddu Tariqa bu ànd amul ci taariix tasawwuf: lu niruwul yoon yu yeneen ñuy jëfandikoo silsila yu borom xam-xam yi di dellu Yonent bi, Tijaan di wax ni ñu jël direct, amul nit bu diggi.",
    expansionChronology: "Chronologie expansion bi",
    tariqaSpecificities: "Li ànd ci Tariqa bi",
    arrivalWestAfrica: "Ñëw ci Afrik àll-géej",
    arrivalIntro: "Tariqa Tijaan ñëw na ci Afrik àll-géej ci njëkk at 19ème siècle ci ay yoon yu bari:",
    universalHeritage: "Njàmbaar bu àdduna",
    universalHeritageDesc: "Tey, Tariqa Tijaan am na ay million taalibe ci àdduna bi yépp, ci Marok ba Nigeria, ci Mauritanie ba Soudan. Tiwaawaan des na benn ci senter bu sell yu gën leer, muy yekkati jàng bu dëgg bu Cheikh Ahmed Tijani ci silsila Maodo.",
    
    // Page Géographie Sacrée
    holyCity: "Tiwaawaan, Dëkk bu Sell",
    geographieHeroDesc: "Lu tax Tiwaawaan nekk senter bu gën mag ci Tijaniyya",
    tivaouaneTransformation: "Tiwaawaan: Ci Dëkk-Bees ba Métropole bu Sell",
    whyTivaouane: "Lu tax Tiwaawaan?",
    whyTivaouaneDesc: "Tànn bu Maodo ci Tiwaawaan duñu hasard. Ay facteur stratégique ñoo yoonu décision bii:",
    distanceFromPower: "Sori ak nguuru kolonial",
    distanceFromPowerDesc: "Lu niruwul Ndar, capitale colonial fi mu jàngalewoon, Tiwaawaan jox na autonomie bu gën",
    centralPosition: "Position géographique bu diggi",
    centralPositionDesc: "Carrefour diggante ay reew, di yomb dikk taalibe yi",
    fertileLand: "Suuf bu baax te jàmm",
    fertileLandDesc: "Bu baax ngir jàng ak méditation",
    rapidTransformation: "Ci lu gaaw at, Tiwaawaan soppi na ba nekk pôle intellectuel ak spirituel. Taalibe yi dikk ci Senegaal yépp, Gambie, Mauritanie ak Guinée ngir jàng ci Maodo.",
    emblematicPlaces: "Paxas yu xàmme",
    cityOrganization: "Organise Dëkk bi",
    cityOrgIntro: "Tiwaawaan organise na tey ci ñetti pôle yu gën mag:",
    demographicMetamorphosis: "Soppi démographique",
    uniqueCase: "Soppi bii def na Tiwaawaan benn cas bu ànd amul ci Afrik àll-géej: dëkk bu identité am ak prospérité bi bépp jokk ci dimension bu sell bi.",
    moreThanaCity: "Tiwaawaan: Gën Dëkk, État d'Esprit",
    moreThanaDesc: "Tiwaawaan duul paxas géographique rekk. Mooy projet bu sell, utopie bu am fi xam-xam ak diine di dund barab, fi taalibe yu bëgg ñépp di jokk ci sopp Yonent bi (YWS) ak jàng Maodo.",
    cityOfLight: "Dëkk bu Leer",
    
    // Page Ziarra
    ziarraTitle: "Ziarra at yi",
    spiritualPilgrimages: "Ajji bu sell",
    ziarraHeroDesc: "Rendez-vous yu sell yi di organise dund bu sell taalibe Tijaan yi",
    ziarraIntro1: "Ziarra yi mooy ajji yu waxtu yi taalibe Tijaan yi di def Tiwaawaan ngir am doole bu sell, soppisaat bay'a ak am baraka Xaliifa bi.",
    ziarraIntro2: "Gamou gi mooy bëgg-bëgg Maouloud bu àdduna bi yépp, wante Ziarra yi mooy waxtu bu jege taalibe yi ak guide bu sell bi. Moo di dimbali ngir sàmm lien (Râbita) buy jokk Tijaan bu nekk ak silsila Maodo.",
    mainZiarras: "Ziarra yu mag yi",
    program: "Programme",
    spiritualSignificance: "Njariñ bu sell",
    pilgrimGuide: "Guide ajibi",
    ziarraSoulJourney: "Ziarra: Tukki ruu bi",
    ziarraConclusion: "Ziarra duul dem Tiwaawaan rekk ci yaram. Mooy tukki ci biir, hijra bu sell fi taalibe di bay ay mbir àdduna ngir jege Yàlla ci sopp guide am.",
    ziarraGeneraleTitle: "Ziarra Générale 2025",
    ziarraGeneraleDate: "Dibéer 20 avril 2025",
    ziarraGeneraleDesc: "Ziarra bu gën mag, Serigne Babacar Sy moo ko sos ci 1930. Moo di dajale ay téeméer mille taalibe di ñëw ngir soppisaat jëf bu sell bi (bay'a) ak Xaliifa Serigne Babacar Sy Mansour.",
    ziarraMaodoTitle: "Ziarra Maodo",
    ziarraMaodoDate: "Bés dellu ci Yàlla El Hadji Maalik Si (27 Jumada al-Thani)",
    ziarraMaodoDesc: "Ajji bu xam ngir hormale tëkkikat Tiwaawaan. Taalibe yi di dajale ci nebbi bi te jang téere ngir ko hormale.",
    ziarraKhalifesTitle: "Ziarra Xaliifa yi",
    ziarraKhalifesDate: "Bés yi am ci xaliifa bi",
    ziarraKhalifesDesc: "Hormale xaliifa yu bari yi topp Maodo. Xaliifa bu nekk am na bés ziarra bu am.",
    spiritualPreparation: "Préparation bu sell",
    logisticalPreparation: "Préparation logistique",
    sincereIntention: "Am niya bu dëgg balaa dem",
    spiritualPurification: "Set sa xol ci tuub",
    multiplyPrayers: "Yaatal julli ci Yonent bi (YWS) ci tukki bi",
    bookInAdvance: "Réserve paxas toog balaa",
    modestComfortableClothing: "Jàpp yéré yu sell te yu neex",
    bringWirdChapelet: "Yóbbu sa Wird ak sa chapelet",
    bringMoneyHadiya: "Yóbbu xaalis ngir don (Hadiya)",
    followInstructions: "Topp consignes organisateurs yi",
    participateCollectivePrayers: "Bokk ci julli mbooloo yi",
    visitWithReflection: "Ziarra paxas yu sell yi ak xel",
    maintainCleanliness: "Sàmm set paxas yi",
    
    // Common
    readMore: "Gën a xam",
    seeAll: "Xool lépp",
    subscribe: "Bindu",
    search: "Seet...",
    learnMore: "Gën a xam",
    discover: "Gis",
    exploreGallery: "Seetlu galerie bi",
    viewAllVideos: "Xool bidiyo yépp",
    noFeaturedVideos: "Amul bidiyo rafet",
    spiritualPath: "Ci yoon wu sell wu ruu bi",
    
    // Home
    heroTitle: "Tiwaawaan",
    heroSubtitle: "ci Tariqa Tijaan",
    heroDescription: "Seetlu njàmbar bu El Hadji Maalik Si ak jàng Tijaan yi",
    quoteOfDay: "Kàddu bu bés bi",
    upcomingEvents: "Mbir yu ñëw",
    featuredVideos: "Bidiyo yu rafet",
    welcomeMessage: "Dalal jàmm ci site L'empreinte de Maodo!",
    exploreHistory: "Seetlu taariix bi",
    discoverContent: "Gis li gën a baax ci li nu am",
    aboutDescription: "Foyer Tijaan Tiwaawaan dafa nekk tariqa suufi bu El Hadji Maalik Si tëkki, borom xam-xam bu mag ak guide spirituel. Moo di yoon wu sell wu ruu bi di ko yokk ci jëfandikoo dikr ak jàng yi ñu jël ci Yonent bi.",
    
    // Newsletter
    stayInformed: "Xam li am",
    newsletterDesc: "Bindu ngir am xibaar yi ak bés yi",
    enterEmail: "Dugal sa email",
    subscribing: "Bindu...",
    thankYou: "Jërëjëf!",
    privacyNote: "Nu wara sàmm sa yoon. Mën nga génn balaa.",
    subscribers: "Ñi bindu",
    frequency: "Léegi-léegi",
    free: "Jàkkarloo",
    
    // Footer
    allRightsReserved: "Sañ-sañ yi ci kow",
    quickLinks: "Lien gaaw yi",
    followUs: "Toppalu nu",
    aboutSite: "Ci biir site bi",
    
    // Stats
    statsTitle: "Tariqa Tijaan ci limbi",
    pilgrims: "Ajibi Gamou gi",
    onlineFollowers: "Taalibe ci internet",
    daysOfDevotion: "Bés ibaada yi",
    countriesRepresented: "Réew yi",
    
    // Pages
    pageNotFound: "Xëtu bi gisuwul",
    backToHome: "Dellu ci ndakaaru",
    
    // Maodo Page
    theFounder: "Ki Tëkki",
    scholarSaint: "Borom xam-xam, Waliyyu, Tëkkikat Zawiya Tiwaawaan ak Yëngukat Sunna Yonent bi (YWS)",
    maodoIntro: "El Hadji Maalik Si, ñu bëgg ko wax Maodo (kàddu wolof bu tekki \"ki ñu ràng\"), mooy benn ci boroom xam-xam yu mag yu Afrik àll-géej. Boroom Tariqa Tijaan ci Senegaal, moo wàcce Tiwaawaan ba nekk ab senter bu sell bu ndaw bi amul.",
    maodoBio: "Juddu ci 1855 ci dëkk bi ñuy wax Gaya ci penku Senegaal, daldi jëfandikoo dundu bi yépp ci jàng, jàngale ak yëngu Islaam ci yoon wu Yonent Muhammad (YWS). Xam-xam bu baax, diine bu sell ak xel bu baax moo def ko ab référence bu dul soxla ci jamano yu bari.",
    maodoQuote: "Ci Maodo, ñaari yoon moo gën: mooy nit ku xam-xam te ku liggéey, suufi te pragmatik, traditionnel te modern.",
    historicPhotos: "Nataal yu yàgg",
    portraitsOfMaodo: "Nataal Maodo",
    lifePath: "Yoon wu dund bi",
    majorContributions: "Jëf yu mag ya muy def",
    literaryWorks: "Téere yi muy bind",
    literaryHeritage: "Maodo bayyi njàmbaar yu téere yu dul feeñ",
    viewAllWorks: "Xool téere yépp",
    wordsOfWisdom: "Kàddu yu xel",
    eternalLegacy: "Njàmbaar bu dul jeex",
    legacyText: "Tey, ginnaaw téeméer at ci dellusiku bi Yàlla, ndaw Maodo di wéy woon. Tariqa Tijaan nekk na tariqa suufi bu gën mag ci Senegaal, te Gamou Tiwaawaan di dajale ay million yu nit ñépp at. Jàng yi, yi warisaay yi di jox, di leer ay xol ak xel ay million Muslimaan ci àdduna bi yépp.",
    hisSuccessors: "Warisaay yi",
    theGamou: "Gamou gi",
    mayAllahBePleasedWithHim: "Yàlla nangu ko te bëgg ko",
    
    // Timeline
    birth: "Juddoo",
    birthDesc: "Juddu ci kër Daw Fall ci Gaya, département Dagana, ci penku Senegaal.",
    quranMemorization: "Màndarga Alxuraan",
    quranMemorizationDesc: "Màndarga Alxuraan bi yépp ci juróom ñaari at, mu wone xel bu baax ak diine bu sell.",
    islamicStudies: "Jàng Islaam",
    islamicStudiesDesc: "Ñaar-fukki at ak juróom ci jàng buy xool fiqh maliki, théologie, tafsir ak xam-xam Islaam ci ay senter yu bari.",
    saintLouisSettlement: "Toog ci Ndar",
    saintLouisSettlementDesc: "Toog ci Ndar ngir jàngale. Jël tur Maalik Fawade ngir hormale ndey ji ku sell.",
    hajjPilgrimage: "Ajji Makka",
    hajjPilgrimageDesc: "Def Hajj ci 31 at. Toog ñaari at ci Makka, tëral Marseille ak Alexandrie.",
    zawiyaNdar: "Tabaxal Zawiya Ndar",
    zawiyaNdarDesc: "Tabax zawiya bu njëkk ci Ndar, senter jàngale ak diine.",
    tivaouaneSettlement: "Toog ci Tiwaawaan",
    tivaouaneSettlementDesc: "Ci woowaali Djibril Gueye, mu toog ba pare ci Tiwaawaan ginnaaw toog ci Ndiarndé.",
    zawiyaTivaouane: "Tëkkili Zawiya Tiwaawaan",
    zawiyaTivaouaneDesc: "Sos zawiya bu mag bi ci Tiwaawaan ak njëkk Gamou.",
    returnToGod: "Dellu ci Yàlla",
    returnToGodDesc: "Ci 27 juin 1922, El Hadji Maalik Si dellu ci Boroom bi ci Tiwaawaan, fi ñu ko nebbi.",
    
    // Contributions
    gamouFounder: "Tëkkikat Gamou gi",
    gamouFounderDesc: "Njëkk Gamou bu njëkk organise ci Senegaal ci 1902",
    schoolBuilder: "Tabaxkat daara",
    schoolBuilderDesc: "Tëkki daara yu bari ci Djolof ak Walo",
    tijaniyyaSpreader: "Yëngukat Tijaan",
    tijaniyyaSpreaderDesc: "Yëngu Tariqa Tijaan, nekk tariqa suufi bu gën mag ci Senegaal",
    manOfPeace: "Nit ku jàmm",
    manOfPeaceDesc: "Waxtan ak kolonikatër yi ci jàmm te du xare",
    prolificAuthor: "Bindikat bu bari",
    prolificAuthorDesc: "Bind téere yu mag ci théologie, tasawwuf ak sunna",
    sunnaReviver: "Yëngukat Sunna",
    sunnaReviverDesc: "Modèle bu pare bu diine, muy jël ci jàng Yonent bi (YWS)",
    
    // Quotes context
    onAction: "Ci njariñ liggéey",
    onDivineKnowledge: "Ci xam Yàlla",
    onPropheticLove: "Ci sopp Yonent bi",
    
    // Khalifes Page
    lineageOfHeirs: "Warisaay yi",
    heirsSubtitle: "Warisaay Maodo: Sàmmukat njàmbaar bu sell bi",
    heirsIntro: "Ginnaaw dellusiku Yàlla bi El Hadji Maalik Si ci 1922, ay xaliifa jàppu ndaw Tariqa Tijaan Tiwaawaan. Ñu nekk ñépp jàppale na tàbbi bi, di jëlsi jàng Maodo ci jamano ak suuf.",
    successionPrinciple: "",
    majorContributionsLabel: "Jëf yu mag:",
    currentKhalife: "Xaliifa tey",
    unbrokenChain: "Silsila bu sell bu duggul",
    chainText: "Ci Maodo ba tey, yónneef baraka (ndam bu sell) duggul. Xaliifa bu nekk mooy benn xaaj ci silsila buy dellu Yonent Muhammad (YWS) jëm Cheikh Ahmed Tijani.",
    continuityGuarantee: "Doxin bii moo di garantie bu dëgg yoon bi ak topp jàng bu njëkk bi.",
    mayAllahBePleasedWithThemAll: "Yàlla nangu leen ñépp",
    
    // Khalifes titles
    firstKhalife: "Xaliifa bu njëkk",
    multidimensionalScholar: "Borom xam-xam bu bari",
    socialRegulator: "Régulateur social",
    tirelessServant: "Jaam bu dul sew",
    ascetOfFass: "Zahid Fass - Borom Fass",
    protectorOfKnowledge: "Sàmmukat xam-xam",
    multidimensionalVisionary: "Visionnaire bu bari",
    builderAndDiplomat: "Tabaxkat ak diplomate",
    currentGuide: "Guide tey",
    
    // Family Tree Page
    spiritualLineage: "Silsila bu sell",
    familyTreeTitle: "Garab njàmbaar",
    familyTreeSubtitle: "Doomu El Hadji Maalik Si ak jàppuwaay xaliifa yi",
    clickToExpand: "Bës ci benn nit ci waa kër gi ngir gis doom yi",
    aboutThisTree: "Ci biir garab bii",
    treeDescription: "Garab njàmbaar bii di wone ab xool bu gaaw ci doomu El Hadji Maalik Si, di gën a wone xaliifa yi ak nit yu mag ci waa kër gi.",
    extendedFamily: "Waa kër Maodo dafa metti lool, ay téeméer doom yu séddale ci Senegaal ak àdduna bi yépp.",
    viewDetailedPage: "Xool xëtu warisaay yi bu sedd",
    legend: "Légende",
    founder: "Tëkkikat (Maodo)",
    descendants: "Doomu",
    
    // Interactive Map Page
    sacredPlaces: "Paxas yu sell",
    mapTitle: "Kart Tiwaawaan",
    mapSubtitle: "Gis paxas yu sell ak yu taariix ci dëkk bu sell bi",
    placesToDiscover: "Paxas yu gis",
    grandMosque: "Jàkka bu mag bi",
    grandMosqueDesc: "Senter diine ak paxas ndaje",
    mausoleum: "Mausolée Maodo",
    mausoleumDesc: "Fi El Hadji Maalik Si nebbi",
    mainZawiya: "Zawiya bu mag bi",
    mainZawiyaDesc: "Senter jàngale ak diine",
    library: "Bibliothèque Islaam",
    libraryDesc: "Sàmm téere yi ak manuscrit yi",
    
    // Contact Page
    contactUs: "Jokkoo ak nu",
    contactSubtitle: "Noo ngi fi ngir la dimbali",
    yourName: "Sa tur",
    yourEmail: "Sa email",
    subject: "Sujet",
    message: "Bataaxal",
    send: "Yónnee",
    sending: "Di yónnee...",
    messageSent: "Bataaxal bi yónnee na bu baax!",
    address: "Adress",
    phone: "Telefon",
    
    // Events
    ziarraGenerale: "Ziarra Générale 2025",
    gamou2025: "Gamou 2025",
    hadratoulJoumah: "Hadratoul Joumah",
    everyFriday: "Ajjuma bu nekk",
    
    // Citations
    quote1: "Xam-xam te liggéeyul dafa ni garab bu amul xob.",
    quote2: "Ku xam Yàlla, xol am mu dal.",
    quote3: "Sopp Yonent bi (YWS) mooy caabi bu nekk baax.",
    quote4: "Xam-xam dafa nekk leer buy leer xol mu gëm.",
    quote5: "Muñ ci épreuve mooy xàmme gëm bu dëgg.",
    
    // CarteTivaouane Page
    sacredGeographyLabel: "Suuf bu sell",
    interactiveMapTitle: "Kart Tiwaawaan",
    discoverHolyPlaces: "Gis paxas yu sell ci dëkk bu sell bi",
    holyPlaces: "Paxas yu sell",
    selectPlace: "Tànn ab paxas",
    selectPlaceDesc: "Bës ci ab paxas ci liste bi ngir gis ay njëkk ak am yoon.",
    getDirections: "Am yoon",
    legendTitle: "Légende",
    mosque: "Jàkka",
    mausoleumType: "Mausolée",
    zawiyaType: "Zawiya",
    eventPlace: "Paxas mbir",
    residence: "Kër",
    libraryType: "Bibliothèque",
    howToGetThere: "Nan ngay dem Tiwaawaan?",
    fromDakar: "Ci Dakar",
    fromDakarDesc: "~90 km (1h30 ci oto ci autoroute A1)",
    fromThies: "Ci Thiès",
    fromThiesDesc: "~20 km (30 min ci oto)",
    transport: "Transport",
    transportDesc: "Bus, taxi ak cars rapides am na",
    openAllDay: "Ubbi 24/24 ngir julli",
    accessibleDuringPrayer: "Mën ngaa dugg ci waxtu julli",
    hadratoulJoumahTime: "Hadratoul Joumah: Ajjuma bu nekk ginnaaw Asr",
    usedDuringGamou: "Jëfandikoo ci Gamou",
    visitsByAppointment: "Ziarra ak rendez-vous",
    libHours: "Altine-Gàww: 9h-17h",
    
    // Gamou Page
    annualCelebration: "Bëgg-bëgg at",
    gamouTitle: "Gamou Tiwaawaan",
    mawlidAnNabawi: "Maouloud an-Nabawi",
    gamouHeroDesc: "Ndaje bu gën mag ci Afrik àll-géej ngir hormale juddu Yonent Muhammad (YWS)",
    gamouIntro1: "Gamou Tiwaawaan dafa gën benn bëgg-bëgg diine: mooy waxtu diine bu sell lool, ajji at bu topp sopp Tijaan yi ci Yonent Muhammad (YWS) ak jàpp ci xéwalam.",
    gamouIntro2: "El Hadji Maalik Si moo ko tëkki ci njëkk at 20ème siècle, Gamou Tiwaawaan nekk na rendez-vous bu dul soxla ci Tijaniyya Senegaal ak Afrik àll-géej. At bu nekk, ci 12ème bés bu weer Rabi' al-Awwal, ay million mu gëm di dem dëkk bu sell bi.",
    gamouSpirit: "Xel Gamou gi",
    gamouSpiritText: "Duul xaaral juddu rekk, wante dafa am ngir yëngu ci xol bu nekk sopp Yonent bi (YWS) ak soppisaat jëfandikoo yoon bu sell bi.",
    gamouHistoryTitle: "Taariix Gamou Tiwaawaan",
    gamouHistory1: "Bëgg-bëgg Maouloud (juddu Yonent bi) amul woon ci Senegaal balaa El Hadji Maalik Si. Mooy ki ko tëkki ci Tiwaawaan ci njëkk at 20ème siècle.",
    gamouHistory2: "Njëkk bëgg-bëgg bi dakk na woon, wante gaaw na yekkati. Maodo gis na ci ab opportunité ngir jàngale xeet bi: 10 bés yi jiitu Maouloud di jëfandikoo ngir jang Bourde (téere soufie) ak jàng valeurs Yonent yi.",
    gamouHistory3: "Ginnaaw dee Maodo ci 1922, warisaay yi yekkati tradition bi. Gamou nekk na ci waxtu événement spirituel bu gën mag ci Senegaal, di dajale personnalités politiques, intellectuels ak surtout ay million taalibe.",
    celebrationProgram: "Déroulement bëgg-bëgg yi",
    tenDaysOfBourde: "10 Bés Bourde",
    tenDaysOfBourdeDesc: "Jang téere Al-Burda Al-Bousayri ngir hormale Yonent bi (YWS), ak chants spirituels",
    nightlyTalks: "Causeries guddi",
    nightlyTalksDesc: "Tafsir yu mag ak jàng yi borom xam-xam yi di jox ci guddi yi jiitu Maouloud",
    massGathering: "Ndaje bu mag",
    massGatheringDesc: "Ay million mu gëm di dikk ci Afrik yépp ak àdduna bi yépp",
    mawlidNight: "Guddi Maouloud",
    mawlidNightDesc: "Topp bëgg-bëgg yi ak julli mbooloo ak baraka yi",
    practicalInfo: "Xibaar yu jariñ",
    gamouDate: "Guddi Alxames 4 ba Àjjuma 5 septembre 2025 (12 Rabi' al-Awwal)",
    mainLocation: "Paxas bu mag bi",
    mainLocationDesc: "Jàkka bu mag Tiwaawaan ak ci wet (Champs de courses)",
    attendance: "Ñi ñëw",
    attendanceDesc: "Gën 5 million ajibi at bu nekk",
    pilgrimAdvice: "Diggu ajibi yi",
    beforeDeparture: "Balaa dem",
    onSite: "Fii",
    bookAccommodation: "Réserve paxas toog ay ayu-bés balaa",
    modestClothing: "Jàpp yéré yu rafet (yéré yu sell)",
    bringWird: "Yóbbu sa Wird ak sa chapelet",
    followOrganizers: "Topp mbir organisateurs yi",
    participateBourde: "Bokk ci séances Bourde ak dhikr",
    keepClean: "Sàmm set paxas yu sell yi",
    appointmentWithEternity: "Rendez-vous ak ba fàww",
    gamouConclusion: "Gamou Tiwaawaan duul ndaje mbooloo rekk. Mooy waxtu asamaan ak suuf di jokk, fi xol mu gëm yi di dem ba pare ci sopp bu baax bu nit yi, Muhammad (YWS).",
    peaceAndBlessings: "Yàlla musal ko jàmm ak baraka",
    
    // Ziarra Page
    ziarraTitle: "Ziarra at yi",
    spiritualPilgrimages: "Ajji bu sell",
    ziarraHeroDesc: "Rendez-vous yu sell yi di organise dund bu sell taalibe Tijaan yi",
    ziarraIntro1: "Ziarra yi mooy ajji yu waxtu yi taalibe Tijaan yi di def Tiwaawaan ngir am doole bu sell, soppisaat bay'a ak am baraka Xaliifa bi.",
    ziarraIntro2: "Gamou gi mooy bëgg-bëgg Maouloud bu àdduna bi yépp, wante Ziarra yi mooy waxtu bu jege taalibe yi ak guide bu sell bi. Moo di dimbali ngir sàmm lien (Râbita) buy jokk Tijaan bu nekk ak silsila Maodo.",
    mainZiarras: "Ziarra yu mag yi",
    ziarraGeneraleTitle: "Ziarra Générale 2025",
    ziarraGeneraleDate: "Dibéer 20 avril 2025",
    ziarraGeneraleDesc: "Ziarra bu gën mag, Serigne Babacar Sy moo ko sos ci 1930. Moo di dajale ay téeméer mille taalibe di ñëw ngir soppisaat jëf bu sell bi (bay'a) ak Xaliifa Serigne Babacar Sy Mansour.",
    ziarraMaodoTitle: "Ziarra Maodo",
    ziarraMaodoDate: "Bés dellu ci Yàlla El Hadji Maalik Si (27 Jumada al-Thani)",
    ziarraMaodoDesc: "Ajji bu xam ngir hormale tëkkikat Tiwaawaan. Taalibe yi di dajale ci nebbi bi te jang téere ngir ko hormale.",
    ziarraKhalifesTitle: "Ziarra Xaliifa yi",
    ziarraKhalifesDate: "Bés yi am ci xaliifa bi",
    ziarraKhalifesDesc: "Hormale xaliifa yu bari yi topp Maodo. Xaliifa bu nekk am na bés ziarra bu am.",
    program: "Programme",
    spiritualSignificance: "Njariñ bu sell",
    pilgrimGuide: "Guide ajibi",
    spiritualPreparation: "Préparation bu sell",
    logisticalPreparation: "Préparation logistique",
    sincereIntention: "Am niya bu dëgg balaa dem",
    spiritualPurification: "Set sa xol ci tuub",
    multiplyPrayers: "Yaatal julli ci Yonent bi (YWS) ci tukki bi",
    bookInAdvance: "Réserve paxas toog balaa",
    modestComfortableClothing: "Jàpp yéré yu sell te yu neex",
    bringWirdChapelet: "Yóbbu sa Wird ak sa chapelet",
    bringMoneyHadiya: "Yóbbu xaalis ngir don (Hadiya)",
    followInstructions: "Topp consignes organisateurs yi",
    participateCollectivePrayers: "Bokk ci julli mbooloo yi",
    visitWithReflection: "Ziarra paxas yu sell yi ak xel",
    maintainCleanliness: "Sàmm set paxas yi",
    ziarraSoulJourney: "Ziarra: Tukki ruu bi",
    ziarraConclusion: "Ziarra duul dem Tiwaawaan rekk ci yaram. Mooy tukki ci biir, hijra bu sell fi taalibe di bay ay mbir àdduna ngir jege Yàlla ci sopp guide am.",
    
    // Mediatheque Page
    mediathequeTitle: "Médiathèque",
    mediathequeSubtitle: "Seetlu collection multimédia yi ci Tariqa Tijaan",
    mediathequeIntro: "Médiathèque Tiwaawaan di dajale collection bu fill bu audiovisuel, nataal ak bind ci taariix, jàng ak dund bu sell Tariqa Tijaan. Sunu but mooy def njàmbaar bii accessible ci nit yu bari.",
    videos: "Bidiyo yi",
    videosDesc: "Conférences, jàng ak mbir yi Tiwaawaan",
    photoLibrary: "Photothèque",
    photoLibraryDesc: "Nataal yu yàgg ak yu tey yu Jàkka bu mag bi ak cérémonies yi",
    manuscripts: "Manuscrits",
    manuscriptsDesc: "Téere yu numérisé El Hadji Maalik Si ak borom xam-xam yu bari",
    audioArchives: "Archives Audio",
    audioArchivesDesc: "Causeries, tafsirs ak chants spirituels enregistrés",
    recentVideos: "Bidiyo yu mujj",
    officialChannels: "Chaînes officielles",
    followLiveEvents: "Topp mbir Tiwaawaan yi en direct",
    downloadableResources: "Ressources téléchargeables",
    maodoWorksDigital: "Téere Maodo yi ci format numérique",
    digitalLibrary: "Bibliothèque Numérique",
    maodoWorks: "Téere Maodo",
    maodoWorksDesc: "Kifâyat ar-Râghibîn, téere soufie, correspondances ak bind yu bari El Hadji Maalik Si disponibles ngir téléchargement.",
    consultLibrary: "Seetlu bibliothèque bi",
    historicalArchives: "Archives Historiques",
    historicalArchivesDesc: "Nataal yu yàgg, manuscrits, enregistrements audio ak documents historiques di sàmm xam-xam Tiwaawaan.",
    exploreArchives: "Seetlu archives yi",
    contributeMediatheque: "Jàppale ci Médiathèque bi",
    contributeDesc: "Am nga documents, nataal, enregistrements mbaa bidiyo ci Tiwaawaan? Dimbali nu di enrich collection bi ngir jamano yi ñëw.",
    submitDocument: "Yónnee ab document",
    subscribeChannel: "Bindu",
    views: "gis",
    
    // École de Tivaouane Page
    ecoleTitle: "Daara Tiwaawaan",
    ecoleSubtitle: "Jàngale Nit ku Baax",
    popularUniversity: "Université Populaire",
    ecoleHeroDesc: "Méthode pédagogique bu El Hadji Maalik Si moo soppi jàngale Islaam ci Afrik àll-géej",
    ecoleIntro1: "Daara Tiwaawaan duul institution ci sens modern, wante mooy système de jàngale buy dund bu El Hadji Maalik Si sos, moo nekkoon ngir jàngale ay muslim yu leer, borom xam-xam te borom jikko yu baax.",
    ecoleIntro2: "Ci 1902, Maodo tëkki zawiya (école coranique) bu gaaw na ba nekk senter buy jële ay mille taalibe. Pédagogie am dafa nekk accessibilité: ni daara élitistes waxtu bi, Tiwaawaan di jot nit ku nekk xam-xam, alal walla ñàkk, Wolof mbaa Sérère, dëkk walla dëkk-bees.",
    maodoVision: "Vision Maodo",
    maodoVisionQuote: "Xam-xam diine war na nekk accessible ci nit ku nekk. Gej buy xam Yàlla am na solo gën borom xam-xam bu ràng.",
    pedagogicalMethod: "Méthode Pédagogique",
    integralTeaching: "Jàngale bu Fill",
    integralTeachingDesc: "Jàpp xam-xam diine (Coran, Hadith, Fiqh) ak xam-xam àdduna (mathématiques, làkk yi)",
    oralPedagogy: "Pédagogie Oral",
    oralPedagogyDesc: "Yónne direct ci maître ba taalibe, di dimbali memorisation ak xam bu sell",
    spiritualFormation: "Jàngale bu Sell",
    spiritualFormationDesc: "Ginnaaw xam-xam, éducation jikko (Akhlaq) ak set ruu (Tazkiyya)",
    guidingPrinciples: "Principes Directeurs",
    freeEducation: "Jàkkarloo Jàngale",
    freeEducationDesc: "Éducation ci Tiwaawaan nekk na jàkkarloo. Taalibe yi di ñaan te di fanaan ak communauté bi. Xam-xam nekk na bien sacré bu dul jëndu.",
    scienceSpiritualityBalance: "Équilibre Xam-xam-Spiritualité",
    scienceSpiritualityBalanceDesc: "Maodo wax na xam-xam te amul spiritualité di war ràng, spiritualité te amul xam-xam di war ñakk. Taalibe war na yokk ñaar gi barab.",
    communityService: "Liggéeyal Communauté",
    communityServiceDesc: "Taalibe yi war ñu jëfandikoo xam-xam bi ngir communauté: jàngale xale yi, diggu kër yi, jagle ay xeex.",
    teachingCycles: "Cycles Jàngale",
    elementaryCycle: "Cycle Élémentaire",
    elementaryCycleDesc: "Jang Coran par coeur, njëkk làkk arab, principes de base Islaam",
    middleCycle: "Cycle Moyen",
    middleCycleDesc: "Grammaire arabe (Nahw, Sarf), Fiqh, Hadith, njëkk Tafsir",
    superiorCycle: "Cycle Supérieur",
    superiorCycleDesc: "Spécialisation ci Tafsir, Hadith, Fiqh bu fill, Usul al-Fiqh, Logique (Mantiq)",
    greatMasters: "Borom Xam-xam yu Mag Tiwaawaan",
    greatMastersDesc: "Daara Tiwaawaan moo sos ay sommités ci bépp domaine xam-xam islamique",
    specialties: "Spécialités",
    contribution: "Contribution",
    lastingLegacy: "Njàmbaar buy Dund",
    lastingLegacyDesc: "Tey ba tey, ay fukki daara di yekkati méthode Maodo ci Tiwaawaan ak Senegaal yépp. Ay mille taalibe di jang Coran, làkk arab ak xam-xam islamique ci topp tradition éducative Tijaan.",
    activeDaaras: "Daara yu dund",
    currentStudents: "Taalibe tey",
    yearsOfHistory: "At taariix",
    seekKnowledge: "Seetal xam-xam ba sa juddu ba sa dee"
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Detect browser language and map to supported languages
  const detectBrowserLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage || 'fr';
    const langCode = browserLang.split('-')[0].toLowerCase();
    
    // Map browser language codes to our supported languages
    const languageMap = {
      'fr': 'fr',  // French
      'en': 'en',  // English
      'ar': 'ar',  // Arabic
      'wo': 'wo',  // Wolof
      // Additional mappings for related languages
      'de': 'en',  // German -> English
      'es': 'fr',  // Spanish -> French (Latin-based)
      'pt': 'fr',  // Portuguese -> French (Latin-based)
      'it': 'fr',  // Italian -> French (Latin-based)
    };
    
    return languageMap[langCode] || 'fr'; // Default to French
  };

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    if (saved) {
      return saved; // Use saved preference
    }
    // First visit: detect browser language
    const detected = detectBrowserLanguage();
    localStorage.setItem('language', detected);
    return detected;
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['fr'][key] || key;
  };

  const value = {
    language,
    setLanguage,
    t,
    isRTL: language === 'ar',
    availableLanguages: [
      { code: 'fr', label: 'Français', flag: '🇫🇷' },
      { code: 'en', label: 'English', flag: '🇬🇧' },
      { code: 'ar', label: 'العربية', flag: '🇸🇦' },
      { code: 'wo', label: 'Wolof', flag: '🇸🇳' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
